var trafo =
webpackJsonptrafo([1],{

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_cookie__ = __webpack_require__(236);



var CSRFToken = function CSRFToken() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "hidden",
    name: "csrfmiddlewaretoken",
    value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["a" /* getCookie */])('csrftoken')
  });
};

/* harmony default export */ __webpack_exports__["a"] = (CSRFToken);

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(4);




var DeleteButton = function DeleteButton(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: "text-btn",
    onClick: props.onClick
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "icon icon--trash mr-2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "subtitle"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Delete')));
};

DeleteButton.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
DeleteButton.defaultProps = {
  onClick: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (DeleteButton);

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var RadioButton = function RadioButton(_ref) {
  var id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      label = _ref.label,
      checked = _ref.checked,
      onChange = _ref.onChange;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "radio-button--wrapper form-group mr-5"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    id: id,
    type: "radio",
    name: name,
    value: value,
    onChange: onChange,
    checked: checked
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    className: "radio-button",
    htmlFor: id
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    className: "form-radio-label form-radio-label--large",
    htmlFor: id
  }, label));
};

RadioButton.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (RadioButton);

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loading__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__arena_TrafoTextPreview__ = __webpack_require__(226);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }









var TrafoPreview = /*#__PURE__*/function (_React$Component) {
  _inherits(TrafoPreview, _React$Component);

  var _super = _createSuper(TrafoPreview);

  // Retry 4 times over ~20 seconds
  function TrafoPreview(props) {
    var _this;

    _classCallCheck(this, TrafoPreview);

    _this = _super.call(this, props);
    var initialState = {
      isLoading: true,
      timesTried: 0,
      thumbnailUrl: undefined,
      text: undefined,
      textProperties: undefined
    };

    if (props.file && props.file.type.startsWith('image')) {
      initialState.thumbnailUrl = props.file.preview;
    }

    _this.state = initialState;
    return _this;
  }

  _createClass(TrafoPreview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.state.thumbnailUrl && this.props.mediaItem && this.props.mediaItem.id) {
        this.fetchPreview();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.retryTimeout) {
        clearTimeout(this.retryTimeout);
      } // Revoke preview to avoid memory leaks


      if (this.props.file) {
        window.URL.revokeObjectURL(this.props.file);
      }
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      if (this.props.file && this.props.file.name) {
        return this.props.file.name;
      } else if (this.props.mediaItem && this.props.mediaItem.title) {
        return this.props.mediaItem.title;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Preview');
    }
  }, {
    key: "fetchPreview",
    value: function fetchPreview() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].mediaPreviewDetail.fetch({
        pk: this.props.mediaItem.id
      }, {
        size: this.props.size
      }).then(function (response) {
        if (response.icon_class && response.icon_class.includes('fa-spinner')) {
          if (_this2.state.timesTried < TrafoPreview.RETRY_TIMEOUTS.length) {
            _this2.retryTimeout = setTimeout(function () {
              return _this2.fetchPreview();
            }, TrafoPreview.RETRY_TIMEOUTS[_this2.state.timesTried]);

            _this2.setState(function (currentState) {
              return {
                isLoading: true,
                timesTried: currentState.timesTried + 1
              };
            });
          } else {
            // Give up after retrying a couple of times
            _this2.setState({
              isLoading: false
            });
          }
        } else {
          _this2.setState({
            thumbnailUrl: response.thumbnail_url,
            text: _this2.props.size === 'large' ? response.text : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["c" /* truncateWords */])(response.text, 20),
            textProperties: response.text_context
          });
        }

        if (_this2.props.finishedLoadingCallback) {
          _this2.props.finishedLoadingCallback(!!_this2.props.onClick);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var content = '';
      var _this$props = this.props,
          mediaItem = _this$props.mediaItem,
          showPreview = _this$props.showPreview,
          size = _this$props.size,
          showUnavailable = _this$props.showUnavailable,
          showNewlyPublished = _this$props.showNewlyPublished,
          onClick = _this$props.onClick,
          className = _this$props.className;

      if (this.state.thumbnailUrl) {
        if (mediaItem && mediaItem.isVideo) {
          // width:100% and height:100% do not force mediaplayer to resize properly if put into stylesheet
          content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "trafo-artwork-preview-video"
          }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("video", {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
              preview: showPreview
            }),
            src: mediaItem.videoUrl,
            poster: this.state.thumbnailUrl,
            title: this.getTitle(),
            width: "100%",
            height: "100%"
          }));
        } else if (mediaItem && mediaItem.isAudio) {
          content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "trafo-artwork-preview-audio"
          }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "trafo-artwork-preview-audioimage",
            title: this.getTitle(),
            style: {
              backgroundImage: "url(".concat(this.state.thumbnailUrl, ")")
            }
          }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("audio", {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
              preview: showPreview
            }),
            src: mediaItem.audioUrl
          }));
        } else {
          content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
            className: "trafo-preview__image",
            src: this.state.thumbnailUrl,
            alt: this.getTitle()
          });
        }

        if (mediaItem && mediaItem.objectUrl && !onClick) {
          var isPDF = mediaItem.isPdf;

          var _className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
            'trafo-preview__pdf-link': isPDF,
            'trafo-preview__artwork-link': !isPDF,
            preview: showPreview && !isPDF
          });

          var newTab = isPDF ? '_blank' : '';
          var pdfReadMoreButton = isPDF && mediaItem.pdfNumberOfPages > 1 && showPreview ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
            className: "btn btn-primary mb-0 border-0"
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Read more')) : '';
          content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
            href: mediaItem.objectUrl,
            className: _className,
            target: newTab
          }, content, pdfReadMoreButton);
        }
      } else if (this.state.text) {
        if (size === 'large') {
          var textProperties = this.state.textProperties;
          content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__arena_TrafoTextPreview__["a" /* default */], {
            className: 'm-3',
            title: undefined,
            text: this.state.text,
            align: textProperties ? textProperties.text_align : 'left',
            font: textProperties ? textProperties.text_font : 'sans-small',
            lineHeight: textProperties ? textProperties.text_lineheight : 'small'
          });
        } else {
          content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "trafo-preview__text"
          }, this.state.text);
        }
      } else if (this.state.isLoading) {
        content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Loading__["a" /* default */], null);
      }

      if (content === '' && showUnavailable) {
        content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "trafo-preview__unavailable"
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Sorry! The preview is not available.'));
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
          'trafo-preview': true,
          'trafo-preview--small': size === 'small',
          'trafo-preview--medium': size === 'medium',
          'trafo-preview--large': size === 'large'
        }),
        onClick: onClick
      }, showNewlyPublished ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "trafo-preview__media-published"
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Congratulations. Your media is published!')) : undefined, content);
    }
  }]);

  return TrafoPreview;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TrafoPreview.propTypes = {
  mediaItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    allow_comments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    audioUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    videoUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    objectUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    isVideo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    isAudio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    isPhoto: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    isText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    isPdf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    pdfNumberOfPages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  file: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(File),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['small', 'medium', 'large', null]),
  finishedLoadingCallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showNewlyPublished: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showUnavailable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showPreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
TrafoPreview.defaultProps = {
  mediaItem: null,
  file: null,
  size: null,
  finishedLoadingCallback: undefined,
  showNewlyPublished: false,
  showUnavailable: false,
  showPreview: false,
  onClick: undefined,
  className: ''
};
TrafoPreview.RETRY_TIMEOUTS = [1000, 3000, 5000, 10000];
/* harmony default export */ __webpack_exports__["a"] = (TrafoPreview);

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loading__ = __webpack_require__(56);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }







var UploadBox = /*#__PURE__*/function (_React$Component) {
  _inherits(UploadBox, _React$Component);

  var _super = _createSuper(UploadBox);

  function UploadBox() {
    _classCallCheck(this, UploadBox);

    return _super.apply(this, arguments);
  }

  _createClass(UploadBox, [{
    key: "render",
    value: function render() {
      var _this = this;

      var message = '';

      if (this.props.multiple) {
        message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_text__["a" /* gettext */])('Click here or drop your files to upload');
      } else {
        message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_text__["a" /* gettext */])('Click here or drop your file to upload');
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */], {
        name: this.props.name,
        accept: this.props.accept,
        multiple: this.props.multiple,
        onDrop: function onDrop() {
          var _this$props;

          return (_this$props = _this.props).onDrop.apply(_this$props, arguments);
        },
        style: {
          height: this.props.height,
          width: this.props.width,
          border: '1px dashed #1D1D1D'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "subtitle h-100 d-flex align-items-center justify-content-center text-center"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
        className: "icon icon--folder--download mr-3"
      }), message, this.props.filesAreBeingUploaded && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "position-absolute mt-5"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Loading__["a" /* default */], null))));
    }
  }]);

  return UploadBox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

UploadBox.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  filesAreBeingUploaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
UploadBox.defaultProps = {
  name: '',
  accept: undefined,
  multiple: true,
  filesAreBeingUploaded: false,
  height: '15rem',
  width: '100%'
};
/* harmony default export */ __webpack_exports__["a"] = (UploadBox);

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ORDERING_CHOICES; });
/* harmony export (immutable) */ __webpack_exports__["a"] = membersReducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return search; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sort; });
/* unused harmony export setUrlHandling */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_urls__ = __webpack_require__(21);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





var history = __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()();
var LOAD_ITEMS = 'memberlist/LOAD_ITEMS';
var SET_SEARCH = 'memberlist/SET_SEARCH';
var SET_ORDERING = 'memberlist/SET_ORDERING';
var SET_URL_HANDLING = 'memberlist/SET_URL_HANDLING';
var ORDERING_CHOICES = {
  choices: [{
    value: 'name',
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('Last name'),
    apiKey: 'user__last_name'
  }, {
    value: 'age',
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('Age'),
    apiKey: '-birth_date'
  }, {
    value: 'joined',
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('Date joined'),
    apiKey: '-user__date_joined'
  }],
  default: 'name'
};
var initialState = {
  items: {},
  itemIds: [],
  limit: 6,
  hasMore: true,
  startLoad: true,
  query: '',
  ordering: ORDERING_CHOICES.default,
  // Some places across trafo, get parameters are used for various stuff, so can't really change the URL
  // without harm done, thus adding an option to skip this
  handleUrl: true
};
function membersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LOAD_ITEMS:
      {
        var normalizedItems = {};
        var itemIds = action.clear ? [] : _toConsumableArray(state.itemIds);
        action.items.forEach(function (item) {
          normalizedItems[item.id] = item;

          if (!itemIds.includes(item.id)) {
            itemIds.push(item.id);
          }
        });
        var items = action.clear ? normalizedItems : _objectSpread(_objectSpread({}, state.items), normalizedItems);
        return _objectSpread(_objectSpread({}, state), {}, {
          hasMore: action.count > itemIds.length,
          items: items,
          itemIds: itemIds,
          startLoad: false
        });
      }

    case SET_SEARCH:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          query: action.query,
          startLoad: true
        });
      }

    case SET_ORDERING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ordering: action.ordering,
          startLoad: true
        });
      }

    case SET_URL_HANDLING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          handleUrl: action.handle
        });
      }

    default:
      {
        return state;
      }
  }
}

var setItems = function setItems(items, count, clear) {
  return {
    type: LOAD_ITEMS,
    items: items,
    count: count,
    clear: clear
  };
};

var makeUrl = function makeUrl(state) {
  var query = state.query,
      ordering = state.ordering;
  var baseUrl = window.location.pathname; // Query parameters to be added to the URL.
  // The keys are parameter names, values are parameter values.

  var queryParams = {
    query: query,
    ordering: ordering
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_urls__["a" /* buildUrl */])(baseUrl, queryParams);
};

var loadItems = function loadItems() {
  var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch, getState) {
    var state = getState();
    var itemIds = state.itemIds,
        limit = state.limit,
        query = state.query,
        ordering = state.ordering,
        handleUrl = state.handleUrl;
    var queryParams = {
      offset: clear ? 0 : itemIds.length,
      limit: limit,
      query: query,
      ordering: ORDERING_CHOICES.choices.find(function (k) {
        return k.value === ordering;
      }).apiKey
    };
    __WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].members.fetch(null, queryParams).then(function (result) {
      dispatch(setItems(result.results, result.count, clear));

      if (handleUrl) {
        var url = makeUrl(state);
        history.replace(url);
      }
    });
  };
};
var search = function search(query) {
  return function (dispatch) {
    dispatch({
      type: SET_SEARCH,
      query: query
    });
    dispatch(loadItems(true));
  };
};
var sort = function sort(ordering) {
  return function (dispatch) {
    dispatch({
      type: SET_ORDERING,
      ordering: ordering
    });
    dispatch(loadItems(true));
  };
};
var setUrlHandling = function setUrlHandling(handle) {
  return function (dispatch) {
    dispatch({
      type: SET_URL_HANDLING,
      handle: handle
    });
  };
};

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mentorsReducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setFilterKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setFilters; });
/* unused harmony export setUrlHandling */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_urls__ = __webpack_require__(21);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





var history = __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()();
var LOAD_ITEMS = 'mentors/LOAD_ITEMS';
var SET_FILTER_KEY = 'mentors/SET_FILTER_KEY';
var SET_FILTERS = 'mentors/SET_FILTERS';
var SET_URL_HANDLING = 'mentors/SET_URL_HANDLING';
var initialState = {
  items: {},
  itemIds: [],
  limit: 6,
  choices: [{
    key: 'all',
    filter: {},
    label: 'All'
  }],
  filters: {},
  filterKey: 'all',
  hasMore: true,
  startLoad: true,
  query: '',
  // Some places across trafo, get parameters are used for various stuff, so can't really change the URL
  // without harm done, thus adding an option to skip this
  handleUrl: true
};
function mentorsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LOAD_ITEMS:
      {
        var normalizedItems = {};
        var itemIds = action.clear ? [] : _toConsumableArray(state.itemIds);
        action.items.forEach(function (item) {
          normalizedItems[item.id] = item;

          if (!itemIds.includes(item.id)) {
            itemIds.push(item.id);
          }
        });
        var items = action.clear ? normalizedItems : _objectSpread(_objectSpread({}, state.items), normalizedItems);
        return _objectSpread(_objectSpread({}, state), {}, {
          hasMore: action.count > itemIds.length,
          items: items,
          itemIds: itemIds,
          startLoad: false
        });
      }

    case SET_FILTER_KEY:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          filterKey: action.filterKey,
          startLoad: true
        });
      }

    case SET_FILTERS:
      {
        return _objectSpread(_objectSpread({}, state), action.filters);
      }

    case SET_URL_HANDLING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          handleUrl: action.handle
        });
      }

    default:
      {
        return state;
      }
  }
}

var setItems = function setItems(items, count, clear) {
  return {
    type: LOAD_ITEMS,
    items: items,
    count: count,
    clear: clear
  };
};

var makeUrl = function makeUrl(state) {
  var filterKey = state.filterKey,
      query = state.query;
  var baseUrl = window.location.pathname; // Query parameters to be added to the URL.
  // The keys are parameter names, values are parameter values.

  var queryParams = {
    filter: filterKey,
    query: query
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_urls__["a" /* buildUrl */])(baseUrl, queryParams);
};

var loadItems = function loadItems() {
  var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch, getState) {
    var state = getState();
    var itemIds = state.itemIds,
        limit = state.limit,
        filterKey = state.filterKey,
        choices = state.choices,
        handleUrl = state.handleUrl;
    var activeFilters = choices.find(function (filter) {
      return filter.key === filterKey;
    });
    var queryParams = {
      offset: clear ? 0 : itemIds.length,
      limit: limit
    };

    if (activeFilters.key !== 'all') {
      queryParams.codename = activeFilters.key;
    }

    __WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].mentors.fetch(null, queryParams).then(function (result) {
      dispatch(setItems(result.results, result.count, clear));

      if (handleUrl) {
        var url = makeUrl(state);
        history.replace(url);
      }
    });
  };
};
var setFilterKey = function setFilterKey(filterKey) {
  return function (dispatch) {
    dispatch({
      type: SET_FILTER_KEY,
      filterKey: filterKey
    });
    dispatch(loadItems(true));
  };
};
/* Used to initially set filters when the app loads form URL with filters prefilled */

var setFilters = function setFilters(filters) {
  return function (dispatch) {
    dispatch({
      type: SET_FILTERS,
      filters: filters
    });
    dispatch(loadItems(true));
  };
};
var setUrlHandling = function setUrlHandling(handle) {
  return function (dispatch) {
    dispatch({
      type: SET_URL_HANDLING,
      handle: handle
    });
  };
};

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newsReducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setFilterKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setFilters; });
/* unused harmony export setUrlHandling */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_urls__ = __webpack_require__(21);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





var history = __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()();
var LOAD_ITEMS = 'news/LOAD_ITEMS';
var SET_FILTER_KEY = 'news/SET_FILTER_KEY';
var SET_FILTERS = 'news/SET_FILTERS';
var SET_URL_HANDLING = 'news/SET_URL_HANDLING';
var initialState = {
  items: {},
  itemIds: [],
  limit: 6,
  choices: [{
    key: 'all',
    filter: {},
    label: 'All'
  }],
  filters: {},
  filterKey: 'all',
  hasMore: true,
  startLoad: true,
  query: '',
  // Some places across trafo, get parameters are used for various stuff, so can't really change the URL
  // without harm done, thus adding an option to skip this
  handleUrl: true
};
function newsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LOAD_ITEMS:
      {
        var normalizedItems = {};
        var itemIds = action.clear ? [] : _toConsumableArray(state.itemIds);
        action.items.forEach(function (item) {
          normalizedItems[item.id] = item;

          if (!itemIds.includes(item.id)) {
            itemIds.push(item.id);
          }
        });
        var items = action.clear ? normalizedItems : _objectSpread(_objectSpread({}, state.items), normalizedItems);
        return _objectSpread(_objectSpread({}, state), {}, {
          hasMore: action.count > itemIds.length,
          items: items,
          itemIds: itemIds,
          startLoad: false
        });
      }

    case SET_FILTER_KEY:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          filterKey: action.filterKey,
          startLoad: true
        });
      }

    case SET_FILTERS:
      {
        return _objectSpread(_objectSpread({}, state), action.filters);
      }

    case SET_URL_HANDLING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          handleUrl: action.handle
        });
      }

    default:
      {
        return state;
      }
  }
}

var setItems = function setItems(items, count, clear) {
  return {
    type: LOAD_ITEMS,
    items: items,
    count: count,
    clear: clear
  };
};

var makeUrl = function makeUrl(state) {
  var filterKey = state.filterKey,
      query = state.query;
  var baseUrl = window.location.pathname; // Query parameters to be added to the URL.
  // The keys are parameter names, values are parameter values.

  var queryParams = {
    filter: filterKey,
    query: query
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_urls__["a" /* buildUrl */])(baseUrl, queryParams);
};

var loadItems = function loadItems() {
  var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch, getState) {
    var state = getState();
    var itemIds = state.itemIds,
        limit = state.limit,
        filterKey = state.filterKey,
        choices = state.choices,
        handleUrl = state.handleUrl;
    var activeFilters = choices.find(function (filter) {
      return filter.key === filterKey;
    });
    var queryParams = {
      offset: clear ? 0 : itemIds.length,
      limit: limit
    };

    if (activeFilters.key !== 'all') {
      queryParams.category = activeFilters.key;
    }

    __WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].news.fetch(null, queryParams).then(function (result) {
      dispatch(setItems(result.results, result.count, clear));

      if (handleUrl) {
        var url = makeUrl(state);
        history.replace(url);
      }
    });
  };
};
var setFilterKey = function setFilterKey(filterKey) {
  return function (dispatch) {
    dispatch({
      type: SET_FILTER_KEY,
      filterKey: filterKey
    });
    dispatch(loadItems(true));
  };
};
/* Used to initially set filters when the app loads form URL with filters prefilled */

var setFilters = function setFilters(filters) {
  return function (dispatch) {
    dispatch({
      type: SET_FILTERS,
      filters: filters
    });
    dispatch(loadItems(true));
  };
};
var setUrlHandling = function setUrlHandling(handle) {
  return function (dispatch) {
    dispatch({
      type: SET_URL_HANDLING,
      handle: handle
    });
  };
};

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_text__ = __webpack_require__(4);




var Preview = function Preview(_ref) {
  var url = _ref.url,
      title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description,
      image = _ref.image;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "featured__item"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "featured__content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: url
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
    className: "mb-0"
  }, title)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "subtitle"
  }, subtitle), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "description"
  }, description), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: url,
    className: "link"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('Read more'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "featured__image"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: url,
    className: "featured__image__image",
    style: image ? {
      backgroundImage: "url('".concat(image, "')")
    } : null
  }, "\xA0")));
};

Preview.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  subtitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Preview);

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var ArenaIcon = function ArenaIcon(_ref) {
  var iconName = _ref.iconName,
      number = _ref.number,
      onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__comments mr-4"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('icon mr-3', "icon--".concat(iconName), className),
    onClick: onClick
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, number));
};

ArenaIcon.propTypes = {
  iconName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
ArenaIcon.defaultProps = {
  onClick: undefined,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (ArenaIcon);

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shapes__ = __webpack_require__(7);




var NonFieldErrors = function NonFieldErrors(_ref) {
  var error = _ref.error,
      className = _ref.className;
  if (!error) return null;
  var errors = [];

  if (typeof error === 'string') {
    errors = [{
      code: 'unknown',
      message: error
    }];
  } else if (error instanceof Array) {
    errors = error;
  }

  if (errors.length < 1) {
    return null;
  }

  return errors.map(function (fieldError) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: className,
      key: fieldError.message
    }, fieldError.message);
  });
};

NonFieldErrors.propTypes = {
  error: __WEBPACK_IMPORTED_MODULE_2__utils_shapes__["b" /* ErrorShape */],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
NonFieldErrors.defaultProps = {
  error: null,
  className: 'alert alert-danger' // Default for bootstrap4

};
/* harmony default export */ __webpack_exports__["a"] = (NonFieldErrors);

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projectsReducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_api__ = __webpack_require__(43);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


var LOAD_ITEMS = 'projects/LOAD_ITEMS';
var initialState = {
  items: {},
  itemIds: [],
  limit: 6,
  hasMore: true,
  startLoad: true
};
function projectsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LOAD_ITEMS:
      {
        var normalizedItems = {};
        var itemIds = action.clear ? [] : _toConsumableArray(state.itemIds);
        action.items.forEach(function (item) {
          normalizedItems[item.id] = item;

          if (!itemIds.includes(item.id)) {
            itemIds.push(item.id);
          }
        });
        var items = action.clear ? normalizedItems : _objectSpread(_objectSpread({}, state.items), normalizedItems);
        return _objectSpread(_objectSpread({}, state), {}, {
          hasMore: action.count > itemIds.length,
          items: items,
          itemIds: itemIds,
          startLoad: false
        });
      }

    default:
      {
        return state;
      }
  }
}

var setItems = function setItems(items, count, clear) {
  return {
    type: LOAD_ITEMS,
    items: items,
    count: count,
    clear: clear
  };
};

var loadItems = function loadItems() {
  var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch, getState) {
    var state = getState();
    var itemIds = state.itemIds,
        limit = state.limit;
    var queryParams = {
      offset: clear ? 0 : itemIds.length,
      limit: limit
    };
    __WEBPACK_IMPORTED_MODULE_0_utils_api__["a" /* default */].projects.fetch(null, queryParams).then(function (result) {
      dispatch(setItems(result.results, result.count, clear));
    });
  };
};

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decodeFormValue; });
/* Value passed from django in data attribute goes through `escapejs` to prevent breaking out. The simpliest way to
   decode it is representing it as json containing single string and parsing it with JSON */
var decodeFormValue = function decodeFormValue(value) {
  return JSON.parse("\"".concat(value, "\""));
};

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildUrl; });
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var reverseUrl = function reverseUrl(urlName) {
  var _DJ_CONST$reverse;

  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return (_DJ_CONST$reverse = DJ_CONST.reverse)[urlName].apply(_DJ_CONST$reverse, params);
};

var buildUrl = function buildUrl(baseUrl, queryParamsObject) {
  /* constructs URL from base url and query params object */
  // Map over pairs of query parameters and values.
  // If the parameter has a value, it is added to the URL, otherwise omitted.
  var queryString = Object.entries(queryParamsObject).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        param = _ref2[0],
        value = _ref2[1];

    return value ? "".concat(param, "=").concat(value) : null;
  }).filter(function (param) {
    return !!param;
  }).join('&'); // Only add the queryString to the URL if there are any query parameters.

  return "".concat(baseUrl).concat(queryString ? "?".concat(queryString) : '');
};
/* harmony default export */ __webpack_exports__["b"] = (reverseUrl);

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dropdown__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_text__ = __webpack_require__(4);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }







var renderSearch = function renderSearch(component) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__search__wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "input-group-prepend"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "input-group-text navbar-light"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "icon icon--search"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    className: "form-control arena__search",
    placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Search'),
    onChange: function onChange(e) {
      return component.setSearch(e.target.value);
    },
    value: component.state.query
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "input-group-text",
    onClick: function onClick() {
      return component.setSearch('');
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "icon icon--cross--dark"
  })))));
};

var renderSort = function renderSort(choices, value, onChange) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__header__sort"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_dropdown___default.a, {
    options: choices,
    arrowClosed: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
      className: "icon icon--chevron"
    }),
    arrowOpen: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
      className: "icon icon--chevron rotate-180"
    }),
    onChange: onChange,
    value: value
  }));
};

var ArenaBase = /*#__PURE__*/function (_Component) {
  _inherits(ArenaBase, _Component);

  var _super = _createSuper(ArenaBase);

  function ArenaBase() {
    var _this;

    _classCallCheck(this, ArenaBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.componentDidUpdate = function (prevProps) {
      var query = _this.props.query; // This checks whether the `query` prop has changed and is not equal to the `query` in state.
      // Used to initially receive the `query` value from query parameters in URL.

      if (prevProps.query !== query && query !== _this.state.query) {
        _this.setState({
          query: query
        });
      }
    };

    _this.setSearch = function (query) {
      _this.setState({
        query: query
      });

      _this.search(query);
    };

    _this.search = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function (input) {
      _this.props.search(input);
    }, 500);

    _this.renderSearch = function () {
      return renderSearch(_assertThisInitialized(_this));
    };

    _this.renderSort = function (choices) {
      return renderSort(choices, _this.props.ordering, function (option) {
        return _this.props.sort(option.value);
      });
    };

    return _this;
  }

  return ArenaBase;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ArenaBase.propTypes = {
  query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  ordering: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  search: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  sort: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ArenaBase);

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AttachmentPreview__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shapes__ = __webpack_require__(7);





var AttachmentPreviewList = function AttachmentPreviewList(_ref) {
  var mediaItems = _ref.mediaItems,
      files = _ref.files,
      onDelete = _ref.onDelete;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "attachment-preview__list"
  }, mediaItems.map(function (mediaItem) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AttachmentPreview__["a" /* default */], {
      key: mediaItem.id,
      mediaItem: mediaItem,
      file: files[mediaItem.id],
      onDelete: onDelete
    });
  }));
};

AttachmentPreviewList.propTypes = {
  mediaItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3__utils_shapes__["k" /* MediaItemShape */]),
  files: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(File)),
  onDelete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
AttachmentPreviewList.defaultProps = {
  mediaItems: [],
  files: {},
  onDelete: null
};
/* harmony default export */ __webpack_exports__["a"] = (AttachmentPreviewList);

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_masonry_css__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_masonry_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_masonry_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_arena_ArenaMediaItem__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_medlemmer_ArenaMemberItem__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_arena_ArenaUploadNewMediaItem__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ducks_arena__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Loading__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_text__ = __webpack_require__(4);













var mapStateToProps = function mapStateToProps(state) {
  return {
    items: state.itemIds.map(function (item) {
      return state.items[item];
    }),
    activeFilters: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_ducks_arena__["f" /* selectActiveFilters */])(state),
    hasMore: state.hasMore,
    startLoad: state.startLoad
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onLoadItems: function onLoadItems() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_ducks_arena__["g" /* loadItems */])());
    }
  };
};

var Arena = function Arena(_ref) {
  var onLoadItems = _ref.onLoadItems,
      hasMore = _ref.hasMore,
      items = _ref.items,
      startLoad = _ref.startLoad,
      actionCallbackFactory = _ref.actionCallbackFactory,
      activeFilters = _ref.activeFilters,
      excludeItem = _ref.excludeItem;
  var allowUploadNew = activeFilters.allowUploadNew,
      uploadNewExtraParams = activeFilters.uploadNewExtraParams;
  var emptyState = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "jumbotron text-center"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils_text__["a" /* gettext */])('Nothing was found. Choose another category or try searching for something else.'));
  var isEmpty = !items.length && !allowUploadNew;

  var renderItems = function renderItems() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller___default.a, {
      initialLoad: false,
      pageStart: 0,
      loadMore: onLoadItems,
      hasMore: hasMore,
      loader: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__loading",
        key: 0
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Loading__["a" /* default */], null))
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_masonry_css___default.a, {
      breakpointCols: {
        default: 3,
        1200: 2,
        768: 1
      },
      className: "arena__masonry",
      columnClassName: "arena__masonry__column"
    }, (allowUploadNew ? [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_arena_ArenaUploadNewMediaItem__["a" /* default */], {
      key: "new-item",
      extraQueryParams: uploadNewExtraParams
    })] : []).concat(items.filter(function (item) {
      if (!item) {
        return false;
      }

      if (excludeItem) {
        return item.id !== excludeItem;
      }

      return true;
    }).map(function (item) {
      if (item.content_type === 'Member') {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_medlemmer_ArenaMemberItem__["a" /* default */], {
          key: "member_".concat(item.id),
          item: item
        });
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_arena_ArenaMediaItem__["a" /* default */], {
        key: item.id,
        item: item,
        actionCallbackFactory: actionCallbackFactory
      });
    }))));
  };

  if (startLoad) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "jumbotron text-center"
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_utils_text__["a" /* gettext */])('Loading… please wait'));
  }

  return !isEmpty ? renderItems() : emptyState;
};

Arena.propTypes = {
  onLoadItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  hasMore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_10_utils_shapes__["d" /* MediaCacheShape */], __WEBPACK_IMPORTED_MODULE_10_utils_shapes__["e" /* MemberShape */]])).isRequired,
  startLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  actionCallbackFactory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  activeFilters: __WEBPACK_IMPORTED_MODULE_10_utils_shapes__["c" /* FilterChoiceShape */],
  excludeItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
Arena.defaultProps = {
  actionCallbackFactory: null,
  activeFilters: null,
  excludeItem: null
};
var ArenaConnected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Arena);
/* harmony default export */ __webpack_exports__["a"] = (ArenaConnected);

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_RadioButton__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ducks_arena__ = __webpack_require__(52);









var renderHelmet = function renderHelmet(title) {
  var pageTitle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_text__["a" /* gettext */])('Trafo.no, the largest society for young artists in the north');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet__["Helmet"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_text__["a" /* gettext */])('Explore'), " \u2014 ").concat(title, " \u2014 ").concat(pageTitle)));
};

var ArenaFilter = function ArenaFilter(_ref) {
  var choices = _ref.choices,
      onChange = _ref.onChange,
      selectedFilterKey = _ref.selectedFilterKey,
      setTitle = _ref.setTitle,
      noFlex = _ref.noFlex;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('arena__filter', {
      'arena__filter--noflex': noFlex
    })
  }, setTitle ? renderHelmet(choices.find(function (filter) {
    return filter.key === selectedFilterKey;
  }).label) : null, choices.map(function (filter) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_RadioButton__["a" /* default */], {
      key: filter.key,
      name: "filter",
      value: filter.key,
      id: filter.key,
      label: filter.label,
      onChange: onChange,
      checked: selectedFilterKey === filter.key
    });
  }));
};

ArenaFilter.propTypes = {
  choices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  // eslint-disable-line
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedFilterKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  setTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  noFlex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ArenaFilter.defaultProps = {
  noFlex: false
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedFilterKey: state.filterKey,
    choices: state.choices
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onChange: function onChange(e) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_ducks_arena__["i" /* setFilterKey */])(e.target.value));
    }
  };
};

var ArenaFilterConnected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ArenaFilter);
/* harmony default export */ __webpack_exports__["a"] = (ArenaFilterConnected);

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_arena_ArenaFavouriteIcon__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaIcon__ = __webpack_require__(150);






var ArenaIconBar = function ArenaIconBar(_ref) {
  var item = _ref.item,
      commentsLink = _ref.commentsLink;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__bottom__right"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: commentsLink
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaIcon__["a" /* default */], {
    iconName: "comment",
    number: item.number_of_public_comments
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_arena_ArenaFavouriteIcon__["a" /* default */], {
    itemId: item.id,
    number: item.number_of_favourites
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaIcon__["a" /* default */], {
    iconName: "eye",
    number: item.number_of_visits
  }));
};

ArenaIconBar.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_2_utils_shapes__["d" /* MediaCacheShape */].isRequired,
  commentsLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ArenaIconBar);

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_constants__ = __webpack_require__(235);






var ArenaItemPreview = function ArenaItemPreview(_ref) {
  var title = _ref.title,
      type = _ref.type,
      itemContent = _ref.itemContent;

  if (itemContent.thumbnail_url) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "arena__item__cover-wrapper"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
      className: "arena__item__image",
      alt: title,
      src: itemContent.thumbnail_url
    }), type === __WEBPACK_IMPORTED_MODULE_4_utils_constants__["a" /* MEDIA_TYPES */].VIDEO && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "arena__item__cover arena__item__cover--video"
    }));
  } else if (itemContent.text) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
      className: "arena__item__text"
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_text__["b" /* nl2br */])(itemContent.text));
  }

  return null;
};

ArenaItemPreview.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  itemContent: __WEBPACK_IMPORTED_MODULE_2_utils_shapes__["f" /* ItemContentShape */].isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ArenaItemPreview);

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_text__ = __webpack_require__(4);





var TrafoTextPreview = function TrafoTextPreview(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(props.className, 'trafo-text-preview', "trafo-text-preview--align--".concat(props.align), "trafo-text-preview--font--".concat(props.font), "trafo-text-preview--line-height--".concat(props.lineHeight))
  }, props.title ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, props.title) : undefined, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_text__["b" /* nl2br */])(props.text)));
};

TrafoTextPreview.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  font: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lineHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
TrafoTextPreview.defaultProps = {
  title: undefined,
  className: null,
  align: 'left',
  font: 'sans-small',
  lineHeight: 'small'
};
/* harmony default export */ __webpack_exports__["a"] = (TrafoTextPreview);

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_UploadBox__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadWorkSubtitle__ = __webpack_require__(229);





var UploadWorkMedia = function UploadWorkMedia(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "upload-work__media"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_UploadBox__["a" /* default */], {
    accept: props.accept,
    multiple: false,
    filesAreBeingUploaded: props.filesAreBeingUploaded,
    onDrop: props.onDrop
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UploadWorkSubtitle__["a" /* default */], {
    withSubtitle: props.withSubtitle
  }));
};

UploadWorkMedia.propTypes = {
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  filesAreBeingUploaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  withSubtitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
UploadWorkMedia.defaultProps = {
  accept: undefined,
  filesAreBeingUploaded: false,
  withSubtitle: true
};
/* harmony default export */ __webpack_exports__["a"] = (UploadWorkMedia);

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeleteButton__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TrafoPreview__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inputs_Input__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inputs_TextArea__ = __webpack_require__(233);









var UploadWorkMediaPreview = function UploadWorkMediaPreview(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "upload-work__media-preview"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "d-flex flex-wrap"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "d-flex flex-column mr-5 mb-4"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TrafoPreview__["a" /* default */], {
    file: props.file,
    mediaItem: props.media,
    size: 'medium'
  }), props.withDelete ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "ml-auto mr-auto mt-2"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DeleteButton__["a" /* default */], {
    onClick: props.onDelete
  })) : null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "d-flex flex-column flex-grow-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "mb-3 text-bold"
  }, props.file ? props.file.name : props.media.title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__inputs_Input__["a" /* default */], {
    className: "mb-3",
    name: "title",
    error: props.errors.title,
    placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Add title'),
    value: props.title,
    onChange: props.handleChange
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__inputs_TextArea__["a" /* default */], {
    className: "mb-3",
    name: "comment",
    rows: 3,
    error: props.errors.comment,
    placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Insert work description that will be displayed under the work'),
    value: props.comment,
    onChange: props.handleChange
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    name: "media",
    value: props.media.id,
    readOnly: true,
    hidden: true
  }))));
};

UploadWorkMediaPreview.propTypes = {
  file: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(File),
  media: __WEBPACK_IMPORTED_MODULE_5__utils_shapes__["k" /* MediaItemShape */].isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  comment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  errors: __WEBPACK_IMPORTED_MODULE_5__utils_shapes__["a" /* ErrorsShape */],
  withDelete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  handleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDelete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
UploadWorkMediaPreview.defaultProps = {
  file: null,
  errors: {},
  withDelete: true,
  handleChange: undefined,
  onDelete: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (UploadWorkMediaPreview);

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_text__ = __webpack_require__(4);




var UploadWorkSubtitle = function UploadWorkSubtitle(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, props.withSubtitle && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "subtitle"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('You can upload JPEG, PNG, GIF, PDF, MP3, OGG, AC3, MPEG, MP4, Flash video, ' + 'as well as the most common microsoft formats, such as WMA and WMV.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "subtitle"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('By submitting your contribution you warrant that you have the copyrights of the grant and ' + 'allowed to publish it on the Internet. Trafo reserves the right to remove contributions that are ' + 'inappropriate or contrary to laws and regulations. Contributions are basically visible to all ' + 'visitors, but you can change them to be private after upload.')));
};

UploadWorkSubtitle.propTypes = {
  withSubtitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
UploadWorkSubtitle.defaultProps = {
  withSubtitle: true
};
/* harmony default export */ __webpack_exports__["a"] = (UploadWorkSubtitle);

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_arena_UploadWorkSubtitle__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inputs_Input__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inputs_TextArea__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inputs_Select__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TrafoTextPreview__ = __webpack_require__(226);











var UploadWorkText = function UploadWorkText(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "upload-work__text"
  }, props.previewingText && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TrafoTextPreview__["a" /* default */], {
    className: props.previewingText ? 'mb-5' : 'mb-5 d-none',
    title: props.values.title,
    text: props.values.text,
    align: props.values.text_align,
    font: props.values.text_font,
    lineHeight: props.values.text_lineheight
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('upload-work__text__form', {
      'd-none': props.previewingText
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__inputs_Input__["a" /* default */], {
    name: "title",
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Title'),
    placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Add title'),
    value: props.values.title,
    error: props.errors.title,
    onChange: props.handleChange,
    required: true
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__inputs_TextArea__["a" /* default */], {
    className: "form-group--huge",
    name: "text",
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Text'),
    placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Text'),
    value: props.values.text,
    error: props.errors.text,
    onChange: props.handleChange,
    required: true
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__inputs_TextArea__["a" /* default */], {
    name: "comment",
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Description'),
    placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Insert work description that will be displayed under the work'),
    value: props.values.comment,
    error: props.errors.comment,
    onChange: props.handleChange
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "form-row align-items-end"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__inputs_Select__["a" /* default */], {
    className: "col-12 col-md-4 col-lg-12 col-xxl-4",
    name: "text_align",
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Select text alignment'),
    options: props.textAlignOptions,
    value: props.values.text_align,
    error: props.errors.text_align,
    onChange: props.handleChange
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__inputs_Select__["a" /* default */], {
    className: "col-12 col-md-4 col-lg-12 col-xxl-4",
    name: "text_font",
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Select font'),
    options: props.textFontOptions,
    value: props.values.text_font,
    error: props.errors.text_font,
    onChange: props.handleChange
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__inputs_Select__["a" /* default */], {
    className: "col-12 col-md-4 col-lg-12 col-xxl-4",
    name: "text_lineheight",
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Select line height'),
    options: props.textLineheightOptions,
    value: props.values.text_lineheight,
    error: props.errors.text_lineheight,
    onChange: props.handleChange
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    name: "access",
    value: 1,
    readOnly: true,
    hidden: true
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_arena_UploadWorkSubtitle__["a" /* default */], {
    withSubtitle: props.withSubtitle
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "btn btn-dark btn-text-light mt-4",
    type: "button",
    onClick: props.toggleTextPreview
  }, props.previewingText ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Edit') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_text__["a" /* gettext */])('Preview')));
};

UploadWorkText.propTypes = {
  textAlignOptions: __WEBPACK_IMPORTED_MODULE_8__utils_shapes__["l" /* SelectOptionsShape */],
  textFontOptions: __WEBPACK_IMPORTED_MODULE_8__utils_shapes__["l" /* SelectOptionsShape */],
  textLineheightOptions: __WEBPACK_IMPORTED_MODULE_8__utils_shapes__["l" /* SelectOptionsShape */],
  values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    comment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    text_align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    text_font: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    text_lineheight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  errors: __WEBPACK_IMPORTED_MODULE_8__utils_shapes__["a" /* ErrorsShape */],
  previewingText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  withSubtitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  handleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  toggleTextPreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
UploadWorkText.defaultProps = {
  textAlignOptions: [],
  textFontOptions: [],
  textLineheightOptions: [],
  errors: {},
  previewingText: false,
  withSubtitle: true,
  handleChange: undefined,
  toggleTextPreview: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (UploadWorkText);

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldErrors__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_shapes__ = __webpack_require__(7);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var Input = function Input(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      touched = _ref.touched,
      error = _ref.error,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["id", "name", "label", "touched", "error", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-group', className)
  }, label ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: id || name
  }, label, props.required ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "asteriskField"
  }, "*") : null) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-control', {
      'is-invalid': error && touched
    }),
    id: id,
    name: name
  }, props)), error && touched ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FieldErrors__["a" /* default */], {
    error: error
  }) : null);
};

Input.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  touched: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  error: __WEBPACK_IMPORTED_MODULE_4__utils_shapes__["b" /* ErrorShape */],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Input.defaultProps = {
  id: null,
  label: null,
  value: null,
  placeholder: null,
  type: 'text',
  touched: true,
  readOnly: false,
  disabled: false,
  error: null,
  className: null,
  required: false,
  onChange: null,
  onBlur: null
};
/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldErrors__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_shapes__ = __webpack_require__(7);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var Select = function Select(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      touched = _ref.touched,
      error = _ref.error,
      className = _ref.className,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, ["id", "name", "label", "touched", "error", "className", "options"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-group', className)
  }, label ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: id || name
  }, label, props.required ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "asteriskField"
  }, "*") : null) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", _extends({
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-control', {
      'is-invalid': error && touched
    }),
    id: id,
    name: name
  }, props), options.map(function (option) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
      value: option.value,
      key: option.value
    }, option.label);
  })), error && touched ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FieldErrors__["a" /* default */], {
    error: error
  }) : null);
};

Select.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  touched: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  error: __WEBPACK_IMPORTED_MODULE_4__utils_shapes__["b" /* ErrorShape */],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  options: __WEBPACK_IMPORTED_MODULE_4__utils_shapes__["l" /* SelectOptionsShape */],
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Select.defaultProps = {
  id: null,
  label: null,
  value: null,
  placeholder: null,
  touched: true,
  readOnly: false,
  disabled: false,
  multiple: false,
  error: null,
  className: null,
  options: [],
  required: false,
  onChange: null,
  onBlur: null
};
/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FieldErrors__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_shapes__ = __webpack_require__(7);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var TextArea = function TextArea(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      touched = _ref.touched,
      error = _ref.error,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["id", "name", "label", "touched", "error", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-group', className)
  }, label ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: id || name
  }, label, props.required ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "asteriskField"
  }, "*") : null) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", _extends({
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('form-control', {
      'is-invalid': error && touched
    }),
    id: id,
    name: name
  }, props)), error && touched ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FieldErrors__["a" /* default */], {
    error: error
  }) : null);
};

TextArea.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  touched: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cols: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  error: __WEBPACK_IMPORTED_MODULE_4__utils_shapes__["b" /* ErrorShape */],
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
TextArea.defaultProps = {
  id: null,
  label: null,
  value: null,
  placeholder: null,
  touched: true,
  readOnly: false,
  error: null,
  className: null,
  required: false,
  onChange: null,
  onBlur: null,
  rows: 3,
  cols: null
};
/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_arena_ArenaItemPreview__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaIcon__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_text__ = __webpack_require__(4);







var ArenaMemberItem = function ArenaMemberItem(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item arena__item--member"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: item.user.link
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_lazyload___default.a, {
    height: item.content_preview.height,
    once: true
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_arena_ArenaItemPreview__["a" /* default */], {
    title: item.user.name,
    itemContent: item.content_preview
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__meta"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: item.user.link
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
    className: "arena__item__title mb-0"
  }, item.user.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("time", {
    className: "arena__item__member__joined"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_text__["a" /* gettext */])('Joined'), " ", item.user.date_joined)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__bottom"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__bottom__left arena__item__bottom__left--member"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__member"
  }, item.age ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__member__age"
  }, item.age, " ", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_text__["a" /* gettext */])('years old')) : undefined), item.user.consultant && item.user.consultant.cat ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__member__mentor"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_text__["a" /* gettext */])('Mentor: '), item.user.consultant.cat.map(function (category) {
    return category.name;
  }).join(', ')) : null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__bottom__right arena__item__bottom__right--member"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "".concat(item.user.link, "#public_p")
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaIcon__["a" /* default */], {
    iconName: "comment",
    number: item.number_of_public_comments
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "".concat(item.user.link, "#arena-wrapper")
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaIcon__["a" /* default */], {
    iconName: "folder--upload",
    number: item.number_of_public_uploads
  }))))));
};

ArenaMemberItem.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_2_utils_shapes__["e" /* MemberShape */].isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ArenaMemberItem);

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VISIBILITY_PUBLIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VISIBILITY_PUBLIC_DISPLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MEDIA_TYPES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text__ = __webpack_require__(4);

var VISIBILITY_PUBLIC = 3;
var VISIBILITY_PUBLIC_DISPLAY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__text__["a" /* gettext */])('Public - everyone can see your comment');
var MEDIA_TYPES = {
  PHOTO: 'P',
  VIDEO: 'V',
  AUDIO: 'A',
  TEXT: 'T'
};

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setCookie */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
/* unused harmony export deleteCookie */
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Set cookie value and when it expires
 * @param name
 * @param value
 * @param days
 */
function setCookie(name, value) {
  var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var expires = '';

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=".concat(date.toGMTString());
  }

  var path = '; path=/'; // Separate variable to get around warning from django's JS translation processing

  document.cookie = "".concat(name, "=").concat(value).concat(expires).concat(path);
}
/**
 * Get cookie value for `name`
 * @param name
 */

function getCookie(name) {
  var cookies = document.cookie.split(';');

  var _iterator = _createForOfIteratorHelper(cookies),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cookie = _step.value;
      // eslint-disable-line no-restricted-syntax
      var trimmedCookie = cookie.trim();

      if (trimmedCookie.startsWith(name)) {
        return trimmedCookie.substring(name.length + 1, trimmedCookie.length);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
}
/**
 * Delete cookie with name
 * @param name
 */

function deleteCookie(name) {
  setCookie(name, '', -1);
}

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scrollElementIntoViewById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollErrorsIntoView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scroll_into_view_if_needed__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_smooth_scroll_into_view_if_needed__ = __webpack_require__(913);
/* Tries to find fields with errors, if any are found scrolls the first one into view
 *
 * Has to be explicitly called in page template, like this:
 *
 * {% block scripts %}
 *   {{ block.super }}
 *   <script>
 *     trafo.scrollErrorsIntoView();
 *   </script>
 * {% endblock scripts %}
 * */



var scrollElementIntoView = function scrollElementIntoView(element, force) {
  // Use native implementation of smooth scrolling if possible
  var scrollIntoViewSmoothly = 'scrollBehavior' in document.documentElement.style ? __WEBPACK_IMPORTED_MODULE_0_scroll_into_view_if_needed__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1_smooth_scroll_into_view_if_needed__["a" /* default */]; // Avoid scrolling if scrolled already

  if (window.scrollY !== 0 && !force) {
    return;
  } // Try scrolling into view


  if (element) {
    // Do with delay, for better UX and to let React components to render
    setTimeout(function () {
      scrollIntoViewSmoothly(element, {
        block: 'start',
        scrollMode: 'if-needed',
        behavior: 'smooth'
      });
    }, force ? 0 : 1000);
  }
};

var scrollElementIntoViewById = function scrollElementIntoViewById(id, force) {
  var element = document.getElementById(id);
  scrollElementIntoView(element, force);
};
var scrollErrorsIntoView = function scrollErrorsIntoView(force) {
  // Avoid scrolling if scrolled already
  if (window.scrollY !== 0 && !force) {
    return;
  } // Search for error labels


  var errorLabels = document.getElementsByClassName('invalid-feedback');

  if (!errorLabels.length) {
    return;
  } // Try scrolling into view


  var formFieldLabel = errorLabels[0].parentElement.parentElement;
  scrollElementIntoView(formFieldLabel, force);
};
/* harmony default export */ __webpack_exports__["a"] = (scrollElementIntoView);

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nl2br;
/* harmony export (immutable) */ __webpack_exports__["c"] = truncateWords;
/* harmony export (immutable) */ __webpack_exports__["a"] = gettext;
/* unused harmony export pgettext */
/* unused harmony export ngettext */
/* unused harmony export interpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* global django */

function nl2br(text) {
  var res = [];
  text.split('\n').forEach(function (x, i) {
    if (i !== 0) {
      res.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
        key: "br-".concat(i)
      })); // eslint-disable-line react/no-array-index-key
    }

    res.push(x);
  });
  return res;
}
function truncateWords(text, times) {
  var words = text.replace(/\n/g, ' ').split(' ', times);
  return words.join(' ');
}
/* The following are global functions that get injected from Django. They allow for translations in JavaScript
   to make their way to .po files.
 */

function gettext(value) {
  return django.gettext(value);
}
function pgettext(context, value) {
  return django.pgettext(context, value);
}
function ngettext(singular, plural, objectCount) {
  return django.ngettext(singular, plural, objectCount);
}
function interpolate(formats, kwargs) {
  var named = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return django.interpolate(formats, kwargs, named);
}

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export apiConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tg_resources__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_cookie__ = __webpack_require__(236);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-template-curly-in-string */



var apiConfig = {
  headers: function headers() {
    return {
      Accept: 'application/json',
      'X-CSRFToken': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_cookie__["a" /* getCookie */])('csrftoken'),
      // Django detects ajax request with X-Requested-With == XMLHttpRequest
      // So pass this with other headers
      'X-Requested-With': 'XMLHttpRequest'
    };
  }
};
var api = new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["a" /* default */]({
  arena: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('mediacache-list')),
  members: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('member-list')),
  projects: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('proj-list')),
  projectMedia: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('project_media-detail', '${pk}')),
  mentors: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('consultant-list')),
  news: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('news-list')),
  favourites: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('favourites_for_current_user')),
  toggleFavourite: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('toggle_favourite_for_current_user', '${mediaCacheId}')),
  mediaUploadPrivate: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('trafo_arena_rest_mediaupload', {
    privacy: 'private'
  })),
  mediaPreviewDetail: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('trafo_arena_rest_mediapreview', '${pk}')),
  mediaDelete: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('trafo_arena_media_delete', '${pk}')),
  commentsForItem: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('comments-for-item', '${model}', '${pk}')),
  commentsPublic: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('comments-public')),
  commentsGuestMentor: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('comments-guestmentor')),
  commentDetail: new __WEBPACK_IMPORTED_MODULE_0_tg_resources__["b" /* Resource */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('comments-detail', '${pk}'))
}, _objectSpread(_objectSpread({}, apiConfig), {}, {
  apiRoot: DJ_CONST.SITE_URL
}));
/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "smoothLinks", function() { return smoothLinks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_react__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_routeMap__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_scrollElemntIntoView__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_handleCustomFileFields__ = __webpack_require__(536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scrollElementIntoView", function() { return __WEBPACK_IMPORTED_MODULE_6__utils_scrollElemntIntoView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scrollErrorsIntoView", function() { return __WEBPACK_IMPORTED_MODULE_6__utils_scrollElemntIntoView__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scrollElementIntoViewById", function() { return __WEBPACK_IMPORTED_MODULE_6__utils_scrollElemntIntoView__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "handleCustomFileFields", function() { return __WEBPACK_IMPORTED_MODULE_7__utils_handleCustomFileFields__["a"]; });
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










if (DJ_CONST.SENTRY_DSN) {
  __WEBPACK_IMPORTED_MODULE_2__sentry_react__["a" /* init */]({
    dsn: DJ_CONST.SENTRY_DSN,
    environment: DJ_CONST.SENTRY_ENVIRONMENT,
    beforeSend: function beforeSend(event, hint) {
      // Check if it is an exception, and if so, show the report dialog
      if (event.exception) {
        __WEBPACK_IMPORTED_MODULE_2__sentry_react__["b" /* showReportDialog */]({
          eventId: event.event_id
        });
      }

      return event;
    }
  }); // If we have authenticated user, pass its data on to Sentry

  if (DJ_CONST.user) {
    __WEBPACK_IMPORTED_MODULE_2__sentry_react__["c" /* setContext */]('user', {
      id: DJ_CONST.user.id,
      email: DJ_CONST.user.email,
      name: DJ_CONST.user.name,
      is_staff: DJ_CONST.user.is_staff
    });
  }
}

function init(routeName) {
  var route = Object.keys(__WEBPACK_IMPORTED_MODULE_5__utils_routeMap__["a" /* default */]).find(function (x) {
    var regex = new RegExp(x);
    return regex.test(routeName);
  });
  var configs = __WEBPACK_IMPORTED_MODULE_5__utils_routeMap__["a" /* default */][route];

  if (!(configs && configs.excludeCommon)) {
    configs = _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_routeMap__["b" /* setupCommonElements */])()), configs);
  }

  if (!configs) {
    return [];
  }

  var stores = {};
  Object.keys(configs).forEach(function (selector) {
    var config = configs[selector];
    var matches = document.querySelectorAll(selector);
    var props = config.props instanceof Function ? config.props() : config.props; // people don't like this hack because other people are dumb
    // don't be dumb - learn javascript before complaining about it on the internet

    [].forEach.call(matches, function (elem) {
      if (!config.reducer) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(config.component, _extends({}, props, elem.dataset)), elem);
        return;
      }

      var store;

      if ('store' in config && config.store in stores) {
        store = stores[config.store];
      } else {
        store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */])(config.reducer);
        stores['store' in config ? config.store : "".concat(routeName, "-").concat(selector)] = store;
      }

      __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__sentry_react__["d" /* ErrorBoundary */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */], {
        store: store
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(config.component, _extends({}, props, elem.dataset)))), elem);
    });
  });
  return stores;
}

function smoothLinks() {
  var _document, _document$querySelect, _document$querySelect2, _document$querySelect3;

  // For some unknown reasons, maybe interfering extensions, instead of a NodeList as per the spec
  // the document.querySelectorAll() call sometimes returns Objects, undefineds...
  (_document = document) === null || _document === void 0 ? void 0 : (_document$querySelect = _document.querySelectorAll) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.call(_document, 'a[href^="#"]')) === null || _document$querySelect2 === void 0 ? void 0 : (_document$querySelect3 = _document$querySelect2.forEach) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.call(_document$querySelect2, function (anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
}

 // eslint-disable-line import/prefer-default-export

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tg_modal__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrafoPreview__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DeleteButton__ = __webpack_require__(105);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }








var AttachmentPreview = /*#__PURE__*/function (_Component) {
  _inherits(AttachmentPreview, _Component);

  var _super = _createSuper(AttachmentPreview);

  function AttachmentPreview(props) {
    var _this;

    _classCallCheck(this, AttachmentPreview);

    _this = _super.call(this, props);

    _this.toggleModal = function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(AttachmentPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          file = _this$props.file,
          mediaItem = _this$props.mediaItem,
          onDelete = _this$props.onDelete;
      var isOpen = this.state.isOpen;
      var shouldRenderModal = !mediaItem.isPdf;
      var canPlayMedia = mediaItem.isVideo && mediaItem.videoUrl || mediaItem.isAudio && mediaItem.audioUrl;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "attachment-preview"
      }, shouldRenderModal && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_tg_modal__["a" /* default */], {
        isOpen: isOpen,
        onCancel: this.toggleModal,
        dialogClassName: "tg-modal-dialog tg-modal-wide",
        title: mediaItem.title,
        autoWrap: true
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TrafoPreview__["a" /* default */], {
        file: file,
        mediaItem: mediaItem,
        size: "large",
        finishedLoadingCallback: canPlayMedia ? DJ_CONST.initTrafoVideoAndAudio : undefined,
        showUnavailable: true,
        showPreview: canPlayMedia
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TrafoPreview__["a" /* default */], {
        file: file,
        mediaItem: mediaItem,
        size: "small",
        onClick: shouldRenderModal ? this.toggleModal : undefined
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "attachment-preview__content"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "text"
      }, mediaItem.title), onDelete && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "ml-2"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DeleteButton__["a" /* default */], {
        onClick: function onClick() {
          return onDelete(mediaItem.id);
        }
      }))));
    }
  }]);

  return AttachmentPreview;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AttachmentPreview.propTypes = {
  file: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(File),
  mediaItem: __WEBPACK_IMPORTED_MODULE_4__utils_shapes__["k" /* MediaItemShape */].isRequired,
  onDelete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
AttachmentPreview.defaultProps = {
  file: null,
  onDelete: null
};
/* harmony default export */ __webpack_exports__["a"] = (AttachmentPreview);

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AttachmentPreviewList__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UploadBox__ = __webpack_require__(108);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }









var Attachments = /*#__PURE__*/function (_React$Component) {
  _inherits(Attachments, _React$Component);

  var _super = _createSuper(Attachments);

  function Attachments(props) {
    var _this;

    _classCallCheck(this, Attachments);

    _this = _super.call(this, props);
    var initialState = {
      files: {},
      mediaItems: [],
      filesBeingUploaded: 0,
      errorMessage: null
    };

    if (props.initialMediaItems) {
      initialState.mediaItems = props.initialMediaItems;
    }

    _this.state = initialState;
    return _this;
  }

  _createClass(Attachments, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Revoke all previews to avoid memory leaks
      this.state.files.forEach(function (file) {
        return window.URL.revokeObjectURL(file.preview);
      });
    }
  }, {
    key: "onDrop",
    value: function onDrop(acceptedFiles, rejectedFiles) {
      var _this2 = this;

      if (this.state.mediaItems.length + acceptedFiles.length > 20) {
        this.setState({
          errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])("You can't upload more than 20 attachments.")
        });
        return;
      }

      if (acceptedFiles.length > 0) {
        acceptedFiles.forEach(function (file) {
          return _this2.uploadFile(file);
        });
      }

      if (rejectedFiles.length > 0) {
        this.setState({
          errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Some of the file(s) you uploaded were rejected because of their type')
        });
      }
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file) {
      var _this3 = this;

      this.setState(function (currentState) {
        return {
          filesBeingUploaded: currentState.filesBeingUploaded + 1
        };
      });
      var attachment = {
        field: 'files',
        file: file,
        name: file.name
      };
      __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].mediaUploadPrivate.post(null, null, null, [attachment]).then(function (result) {
        var response = typeof result === 'string' ? JSON.parse(result) : result;

        if (response.success) {
          var mediaItem = response.uploads[0];

          _this3.setState(function (currentState) {
            return {
              mediaItems: [mediaItem].concat(_toConsumableArray(currentState.mediaItems)),
              files: _objectSpread(_objectSpread({}, currentState.files), {}, _defineProperty({}, mediaItem.id, file))
            };
          });
        } else {
          var name = file.name;
          var reason = result.error ? result.error : '';

          _this3.setState({
            errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])("File upload failed for file ".concat(name, ". ").concat(reason))
          });
        }
      }).finally(function () {
        _this3.setState(function (currentState) {
          return {
            filesBeingUploaded: currentState.filesBeingUploaded - 1
          };
        });
      });
    }
  }, {
    key: "deleteMedia",
    value: function deleteMedia(mediaId) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */].mediaDelete.post({
        pk: mediaId
      }).then(function (result) {
        var newMediaItems = _toConsumableArray(_this4.state.mediaItems);

        var removeIndex = newMediaItems.findIndex(function (mediaItem) {
          return mediaItem.id === mediaId;
        });

        if (removeIndex !== -1) {
          newMediaItems.splice(removeIndex, 1);

          _this4.setState({
            mediaItems: newMediaItems
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "attachments"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UploadBox__["a" /* default */], {
        accept: this.props.accept,
        filesAreBeingUploaded: this.state.filesBeingUploaded > 0,
        onDrop: function onDrop() {
          return _this5.onDrop.apply(_this5, arguments);
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "subtitle mt-4 mb-4"
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Trafo.no supports most common file formats. The files you upload here will only be available in ' + 'the application and will not be published publicly on Trafo.no.')), this.state.errorMessage && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "alert alert-danger"
      }, this.state.errorMessage), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AttachmentPreviewList__["a" /* default */], {
        mediaItems: this.state.mediaItems,
        files: this.state.files,
        onDelete: function onDelete(mediaId) {
          return _this5.deleteMedia(mediaId);
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", {
        name: this.props.name,
        value: this.state.mediaItems.map(function (mediaItem) {
          return mediaItem.id;
        }),
        multiple: true,
        hidden: true,
        readOnly: true
      }, this.state.mediaItems.map(function (mediaItem) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
          key: mediaItem.id,
          value: mediaItem.id
        });
      })));
    }
  }]);

  return Attachments;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Attachments.propTypes = {
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  initialMediaItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4__utils_shapes__["k" /* MediaItemShape */])
};
Attachments.defaultProps = {
  accept: undefined,
  initialMediaItems: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (Attachments);

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CSRFToken__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_inputs_NonFieldErrors__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_UploadBox__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TrafoPreview__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DeleteButton__ = __webpack_require__(105);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable no-underscore-dangle */










var AvatarProfilePic = /*#__PURE__*/function (_React$Component) {
  _inherits(AvatarProfilePic, _React$Component);

  var _super = _createSuper(AvatarProfilePic);

  function AvatarProfilePic(props) {
    var _this;

    _classCallCheck(this, AvatarProfilePic);

    _this = _super.call(this, props);

    var initialState = _objectSpread({}, AvatarProfilePic.emptyState);

    _this.state = initialState;
    return _this;
  }

  _createClass(AvatarProfilePic, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Revoke preview to avoid memory leaks
      if (this.state.file) {
        window.URL.revokeObjectURL(this.state.file);
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop(acceptedFiles, rejectedFiles) {
      this.setState({
        showPreview: true
      });

      if (acceptedFiles.length > 0) {
        var acceptedFile = acceptedFiles[0];
        this.setState({
          file: acceptedFile
        });
      }

      if (acceptedFiles.length > 1) {
        this.setState({
          errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('You can only upload one work at a time.')
        });
      }

      if (rejectedFiles.length > 0) {
        this.setState({
          errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Some of the file(s) you uploaded were rejected because of their type')
        });
      }
    }
  }, {
    key: "deleteMedia",
    value: function deleteMedia() {
      if (this.state.showPreview) {
        this.setState({
          showPreview: false
        });
      }

      if (this.state.file) {
        window.URL.revokeObjectURL(this.state.file);
        this.setState({
          file: null,
          fileId: Math.random()
        });
      }
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      if (!this.state.file) return false;
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var displayPreview = this.state.showPreview && (this.state.file || this.props.initialAvatar);
      var content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "d-flex flex-column"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "col-sm-12 pl-0 pr-0",
        src: this.state.file && this.state.file.preview || this.props.initialAvatar,
        style: {
          display: !displayPreview && 'none'
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          display: displayPreview && 'none'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_UploadBox__["a" /* default */], {
        key: this.state.fileId,
        onDrop: function onDrop() {
          return _this2.onDrop.apply(_this2, arguments);
        },
        accept: this.props.accept,
        multiple: false,
        name: "avatar"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          display: !displayPreview && 'none'
        },
        className: "ml-auto mr-auto mt-2"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DeleteButton__["a" /* default */], {
        onClick: function onClick() {
          return _this2.deleteMedia();
        }
      })));
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "upload-work col-md-5 pl-0 pr-0"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        method: "post",
        noValidate: "noValidate",
        enctype: "multipart/form-data",
        classNames: ""
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CSRFToken__["a" /* default */], null), content, this.state.errorMessage && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "alert alert-danger"
      }, this.state.errorMessage), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_inputs_NonFieldErrors__["a" /* default */], {
        error: this.props.errors.__all__
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "btn btn-primary mt-4 col-md-6 col-md-offset-3",
        type: "submit"
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Upload'))));
    }
  }]);

  return AvatarProfilePic;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AvatarProfilePic.propTypes = {
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  initialAvatar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  errors: __WEBPACK_IMPORTED_MODULE_4__utils_shapes__["a" /* ErrorsShape */]
};
AvatarProfilePic.defaultProps = {
  accept: undefined,
  initialAvatar: null,
  errors: {}
};
AvatarProfilePic.emptyState = {
  showPreview: true,
  media: null,
  file: null,
  fileId: Math.random(),
  errorMessage: null
};
/* harmony default export */ __webpack_exports__["a"] = (AvatarProfilePic);

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tg_modal__ = __webpack_require__(205);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var BurgerMenuLinkShape = {
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var BurgerMenuLink = function BurgerMenuLink(_ref) {
  var href = _ref.href,
      title = _ref.title;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: href
  }, title);
};

BurgerMenuLink.propTypes = BurgerMenuLinkShape;

var BurgerMenu = /*#__PURE__*/function (_Component) {
  _inherits(BurgerMenu, _Component);

  var _super = _createSuper(BurgerMenu);

  function BurgerMenu(props) {
    var _this;

    _classCallCheck(this, BurgerMenu);

    _this = _super.call(this, props);

    _this.toggleModal = function () {
      // change the navbar class to make icons visible on a dark background
      var navbar = window.document.querySelector('.navbar');
      var navbarClass = _this.state.navbarClass;

      if (_this.state.navbarClass === null) {
        navbarClass = Array.prototype.find.call(navbar.classList, function (cls) {
          return cls === 'navbar-light' || cls === 'navbar-dark';
        });

        _this.setState({
          navbarClass: navbarClass
        });
      }

      var isOpen = _this.state.isOpen;

      if (isOpen) {
        // closing: return old class
        navbar.classList.replace('navbar-dark', navbarClass);
      } else {
        // opening: set the dark class
        navbar.classList.replace(navbarClass, 'navbar-dark');
      }

      _this.setState({
        isOpen: !isOpen
      });
    };

    _this.state = {
      isOpen: false,
      navbarClass: null
    };
    return _this;
  }

  _createClass(BurgerMenu, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "burger-menu__wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('hamburger', 'hamburger--squeeze', {
          'is-active': this.state.isOpen
        }),
        onClick: this.toggleModal
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "hamburger-box"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "hamburger-inner"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_tg_modal__["a" /* default */], {
        isOpen: this.state.isOpen,
        onCancel: this.toggleModal,
        isBasic: true,
        isStatic: true,
        dialogClassName: ""
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "burger-menu__content"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "burger-menu__background"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "burger-menu__options"
      }, this.props.links.map(function (section, index) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          key: section.section,
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
            'mt-4': index > 0
          })
        }, section.items.map(function (link) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BurgerMenuLink, {
            href: link.href,
            title: link.title,
            key: link.title
          });
        }));
      })))));
    }
  }]);

  return BurgerMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BurgerMenu.propTypes = {
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    section: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(BurgerMenuLinkShape)).isRequired
  })).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (BurgerMenu);

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommentedItemPreview__ = __webpack_require__(503);





var Comment = function Comment(_ref) {
  var comment = _ref.comment,
      onDelete = _ref.onDelete,
      contentAndImageLinks = _ref.contentAndImageLinks;
  var fullUrl = "".concat(comment.url, "#comment-").concat(comment.id);
  var canDelete = !comment.is_system_comment && !comment.comment_type && DJ_CONST.user && (DJ_CONST.user.id === comment.user_id || DJ_CONST.user.is_staff);
  var button = canDelete ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comment__buttons"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: undefined,
    onClick: onDelete
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "sr-only"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Delete comment')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "icon icon--trash icon-button"
  }))) : null;
  var commentText = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comment__text ".concat(comment.comment_type ? comment.comment_type : ''),
    dangerouslySetInnerHTML: {
      __html: comment.comment_html
    }
  });

  if (contentAndImageLinks) {
    commentText = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: fullUrl
    }, commentText), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: fullUrl,
      className: "link"
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Read more')));
  }

  var commentAttachment = null;

  if (comment.attachment_url) {
    commentAttachment = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "comment__attachment"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, "Attachment:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: comment.attachment_url
    }, comment.attachment_name));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    id: "comment-".concat(comment.id),
    key: comment.id,
    className: "comment"
  }, comment.preview ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CommentedItemPreview__["a" /* default */], {
    preview: comment.preview,
    href: contentAndImageLinks ? fullUrl : null
  }) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comment__content"
  }, comment.is_system_comment ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comment__author"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: "comment__author__avatar",
    href: comment.member_permalink
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "comment__system__avatar"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comment__meta"
  }, button, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: "comment__author__name",
    href: comment.member_permalink
  }, "Trafo.no"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comment__author__time"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: fullUrl
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("time", {
    title: comment.created_at
  }, comment.created_at_natural))))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comment__author"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: "comment__author__avatar",
    href: comment.member_permalink
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: comment.user_avatar_url_small,
    alt: comment.user_full_name
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comment__meta"
  }, button, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: "comment__author__name",
    href: comment.member_permalink
  }, comment.user_full_name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comment__author__time"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: fullUrl
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("time", {
    title: comment.created_at
  }, comment.created_at_natural))), comment.visibility ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subtitle text-muted"
  }, comment.visibility) : null, comment.comment_type === 'mentor-application-report_delivered' || comment.comment_type === 'funding-application-report_delivered' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subtitle text-muted"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Final report')) : null)), commentText, commentAttachment));
};

Comment.propTypes = {
  comment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    user_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    comment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    comment_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    user_full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    member_permalink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    user_avatar_url_small: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    created_at_natural: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    preview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      contenttype: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    attachment_url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    attachment_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    visibility: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    is_system_comment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }).isRequired,
  onDelete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  contentAndImageLinks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Comment.defaultProps = {
  preview: undefined,
  contentAndImageLinks: false
};
/* harmony default export */ __webpack_exports__["a"] = (Comment);

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CSRFToken__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UploadBox__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DeleteButton__ = __webpack_require__(105);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }








/**
 * Component for comment form
 *
 */

var CommentForm = /*#__PURE__*/function (_React$Component) {
  _inherits(CommentForm, _React$Component);

  var _super = _createSuper(CommentForm);

  function CommentForm(props) {
    var _this;

    _classCallCheck(this, CommentForm);

    _this = _super.call(this, props);

    _this.attachmentField = function () {
      var displayPreview = !!_this.state.file;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "d-flex flex-column"
      }, _this.state.file && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        href: _this.state.file && _this.state.file.preview,
        style: {
          display: !displayPreview && 'none'
        },
        target: '_blank'
      }, _this.state.file.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          display: displayPreview && 'none'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UploadBox__["a" /* default */], {
        height: "7rem",
        key: _this.state.fileId,
        onDrop: function onDrop() {
          var _this2;

          return (_this2 = _this).onDrop.apply(_this2, arguments);
        },
        multiple: false,
        name: "attachment"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          display: !displayPreview && 'none'
        },
        className: "ml-auto mr-auto mt-2"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DeleteButton__["a" /* default */], {
        onClick: function onClick() {
          return _this.deleteMedia();
        }
      })));
    };

    _this.visibilityFields = function () {
      var defaultVis = __WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* VISIBILITY_PUBLIC */];
      return Object.entries(_this.props.visibilityChoices).map(function (_ref, index) {
        var _ref2 = _slicedToArray(_ref, 2),
            value = _ref2[0],
            name = _ref2[1];

        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "radio-button--wrapper form-group",
          key: value
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          type: "radio",
          className: "form-check-input",
          defaultChecked: value === defaultVis.toString(10),
          name: "visibility",
          id: "id_visibility_".concat(index),
          value: value
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
          className: "radio-button small",
          htmlFor: "id_visibility_".concat(index)
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
          htmlFor: "id_visibility_".concat(index),
          className: "form-radio-label form-check-inline"
        }, name));
      });
    };

    _this.state = {
      fileId: Math.random()
    };
    return _this;
  }

  _createClass(CommentForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Revoke preview to avoid memory leaks
      if (this.state.file) {
        window.URL.revokeObjectURL(this.state.file);
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop(acceptedFiles, rejectedFiles) {
      if (acceptedFiles.length > 0) {
        var acceptedFile = acceptedFiles[0];
        this.setState({
          file: acceptedFile
        });
      }

      if (acceptedFiles.length > 1) {
        this.setState({
          errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('You can only upload one attachment at a time.')
        });
      }

      if (rejectedFiles.length > 0) {
        this.setState({
          errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Some of the file(s) you uploaded were rejected because of their type')
        });
      }
    }
  }, {
    key: "formActionUrl",
    value: function formActionUrl() {
      return "/commentp/add/".concat(this.props.modelName, "/").concat(this.props.pk, "/");
    }
  }, {
    key: "deleteMedia",
    value: function deleteMedia() {
      if (this.state.file) {
        window.URL.revokeObjectURL(this.state.file);
        this.setState({
          file: null,
          fileId: Math.random()
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var showVisibility = Object.entries(this.props.visibilityChoices).length > 1;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        action: this.formActionUrl(),
        method: "post",
        encType: "multipart/form-data"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CSRFToken__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "div_id_message",
        className: "form-group"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "id_message",
        className: "requiredField"
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Add comment'), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "asteriskField"
      }, "*")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: ""
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", {
        name: "message",
        rows: "10",
        id: "id_message",
        minLength: "1",
        required: true,
        cols: "40",
        className: "textarea form-control"
      }))), this.props.acceptAttachments && this.attachmentField(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comment-addform-tools"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "div_id_visibility",
        className: "form-group ".concat(showVisibility ? '' : 'd-none')
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "id_visibility",
        className: " requiredField"
      }, "Visibility", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "asteriskField"
      }, "*")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "form-check"
      }, this.visibilityFields())), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "buttonHolder"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "submit",
        name: "submit",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Send comment'),
        className: "text-btn link",
        id: "submit-id-submit"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "button-arrow"
      }))));
    }
  }]);

  return CommentForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CommentForm.propTypes = {
  modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pk: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  acceptAttachments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  visibilityChoices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
CommentForm.defaultProps = {
  modelName: null,
  pk: null,
  acceptAttachments: false,
  visibilityChoices: {
    VISIBILITY_PUBLIC: __WEBPACK_IMPORTED_MODULE_4__utils_constants__["c" /* VISIBILITY_PUBLIC_DISPLAY */]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (CommentForm);

/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var CommentedItemPreview = function CommentedItemPreview(_ref) {
  var preview = _ref.preview,
      href = _ref.href;
  var style = preview.thumbnail_url ? {
    backgroundImage: "url(".concat(preview.thumbnail_url, ")")
  } : null;
  var commentPreview = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('trafo-preview', 'trafo-preview-medium', "trafo-preview-".concat(preview.contenttype), {
      'trafo-image-preview': preview.thumbnail_url
    }),
    style: style
  }, !preview.thumbnail_url && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "preview-innertext"
  }, preview.text), !!preview.icon_class && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: preview.icon_class
  }), !!preview.stamp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "preview-stamp"
  }, preview.stamp));

  if (href) {
    commentPreview = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: href
    }, commentPreview);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comment__work"
  }, commentPreview);
};

CommentedItemPreview.propTypes = {
  preview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    thumbnail_url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    stamp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    icon_class: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    contenttype: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
CommentedItemPreview.defaultProps = {
  href: null
};
/* harmony default export */ __webpack_exports__["a"] = (CommentedItemPreview);

/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tg_modal__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loading__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Comment__ = __webpack_require__(501);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }








var commentTypes = {
  FOR_ITEM: 1,
  GUESTMENTOR: 2,
  PUBLIC: 3
};
/**
 * Component for comments display for news, media, projects
 *
 * Not supposed to deal with any application (funding, mentor) pseudo-comments
 */

var Comments = /*#__PURE__*/function (_React$Component) {
  _inherits(Comments, _React$Component);

  var _super = _createSuper(Comments);

  function Comments(props) {
    var _this;

    _classCallCheck(this, Comments);

    _this = _super.call(this, props);
    _this.state = {
      comments: null,
      deletionModalIsOpen: false,
      currentComment: null // to render deletion modal with the comment's text

    };
    return _this;
  }

  _createClass(Comments, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.comments === null) {
        this.fetchComments();
      }
    }
  }, {
    key: "deleteComment",
    value: function deleteComment(_ref) {
      var _this2 = this;

      var id = _ref.id;
      __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].commentDetail.del({
        pk: id
      }).then(function () {
        var comments = _this2.state.comments;

        _this2.setState({
          comments: comments.filter(function (c) {
            return c.id !== id;
          })
        });
      }).catch(function () {// do something?
      });
      this.toggleDeletionModal();
    }
  }, {
    key: "fetchComments",
    value: function fetchComments() {
      var _this3 = this;

      var commentType = this.props.commentType;
      var apiCall;

      if (commentType === commentTypes.FOR_ITEM) {
        apiCall = __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].commentsForItem.fetch({
          pk: this.props.pk,
          model: this.props.modelName
        });
      } else if (commentType === commentTypes.PUBLIC) {
        apiCall = __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].commentsPublic.fetch();
      } else if (commentType === commentTypes.GUESTMENTOR) {
        apiCall = __WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */].commentsGuestMentor.fetch();
      }

      apiCall.then(function (response) {
        _this3.setState({
          comments: response
        });
      }).catch(function () {
        _this3.setState({
          comments: 'ERROR'
        });
      });
    }
  }, {
    key: "toggleDeletionModal",
    value: function toggleDeletionModal(comment) {
      this.setState({
        deletionModalIsOpen: !!comment,
        currentComment: comment
      });
    }
  }, {
    key: "renderComment",
    value: function renderComment(comment) {
      var _this4 = this;

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Comment__["a" /* default */], {
        key: comment.id,
        comment: comment,
        onDelete: function onDelete() {
          return _this4.toggleDeletionModal(comment);
        },
        contentAndImageLinks: this.props.contentAndImageLinks
      });
    }
  }, {
    key: "renderDeletionModal",
    value: function renderDeletionModal() {
      var _this5 = this;

      if (DJ_CONST.user === null) {
        // skip it entirely if not auth'd
        return null;
      }

      var currentComment = this.state.currentComment;
      var commentText = currentComment ? currentComment.comment : '';
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_tg_modal__["a" /* default */], {
        isOpen: this.state.deletionModalIsOpen,
        onCancel: this.toggleDeletionModal,
        isBasic: true,
        isStatic: true,
        dialogClassName: "comment-deletion-modal__wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comment-deletion-modal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Delete comment"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, commentText), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "__buttons"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        onClick: function onClick() {
          return _this5.deleteComment(currentComment);
        }
      }, "Delete"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        onClick: function onClick() {
          return _this5.toggleDeletionModal();
        }
      }, "Cancel"))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var comments = this.state.comments;
      var title;
      var total;
      var renderedComments;

      if (comments === null) {
        title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_text__["a" /* gettext */])('Loading comments...');
        renderedComments = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Loading__["a" /* default */], null);
      } else if (comments === 'ERROR') {
        renderedComments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_text__["a" /* gettext */])('There was an error loading comments.');
      } else if (comments.length > 0) {
        title = this.props.title;

        if (this.props.commentType === commentTypes.FOR_ITEM) {
          total = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "number-of-comments"
          }, comments.length);
        }

        renderedComments = comments.map(function (comment) {
          return _this6.renderComment(comment);
        });
      } else {
        title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_text__["a" /* gettext */])('Be the first one to comment');
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comments__list"
      }, this.renderDeletionModal(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comments__list__heading"
      }, total, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, title)), renderedComments);
    }
  }]);

  return Comments;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Comments.propTypes = {
  modelName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pk: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  commentType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentAndImageLinks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Comments.defaultProps = {
  modelName: null,
  pk: null,
  commentType: commentTypes.FOR_ITEM,
  title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_text__["a" /* gettext */])('Comments'),
  contentAndImageLinks: false
};
Comments.commentTypes = commentTypes;
/* harmony default export */ __webpack_exports__["a"] = (Comments);

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_date_picker__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_forms__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }







var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);

    _this.onChange = function (date) {
      return _this.setState({
        date: date
      });
    };

    var initialDate = props.initialDate,
        provideDefaultDate = props.provideDefaultDate,
        fieldValue = props.fieldValue,
        fieldName = props.fieldName,
        fieldError = props.fieldError,
        datePickerProps = _objectWithoutProperties(props, ["initialDate", "provideDefaultDate", "fieldValue", "fieldName", "fieldError"]);

    var initialState = {
      datePickerProps: datePickerProps
    };

    if (fieldValue) {
      initialState.date = new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_forms__["a" /* decodeFormValue */])(fieldValue));
    } else {
      if (provideDefaultDate) {
        if (__WEBPACK_IMPORTED_MODULE_4_moment___default.a.isDate(initialDate)) {
          initialState.date = initialDate;
        } else {
          initialState.date = new Date();
        }
      }
    }

    _this.state = initialState;
    return _this;
  }

  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          date = _this$state.date,
          datePickerProps = _this$state.datePickerProps;
      var inputProps = {
        name: this.props.fieldName
      };

      if (!date) {
        inputProps.clearIcon = null;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_date_picker___default.a, _extends({
        onChange: this.onChange,
        value: date,
        locale: DJ_CONST.LANGUAGE_CODE
      }, datePickerProps, inputProps)));
    }
  }]);

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DatePicker.propTypes = {
  fieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fieldName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  provideDefaultDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
DatePicker.defaultProps = {
  fieldValue: undefined,
  provideDefaultDate: true
};
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_forms__ = __webpack_require__(153);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var LimitedTextarea = /*#__PURE__*/function (_Component) {
  _inherits(LimitedTextarea, _Component);

  var _super = _createSuper(LimitedTextarea);

  function LimitedTextarea(props) {
    var _this;

    _classCallCheck(this, LimitedTextarea);

    _this = _super.call(this, props);

    _this.countCharacters = function (value) {
      return value.replace(/\r\n/gi, '\n').length;
    };

    _this.checkInput = function () {
      _this.setState({
        count: _this.countCharacters(_this.textareaRef.current.value)
      });
    };

    var fieldValue = _this.props.fieldValue;
    _this.textareaRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.state = {
      count: _this.countCharacters(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_forms__["a" /* decodeFormValue */])(fieldValue))
    };
    return _this;
  } // Treat windows-style line endings as single character


  _createClass(LimitedTextarea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fieldName = _this$props.fieldName,
          fieldValue = _this$props.fieldValue,
          className = _this$props.className,
          rows = _this$props.rows,
          cols = _this$props.cols,
          countShow = _this$props.countShow,
          countLimit = _this$props.countLimit;
      var count = this.state.count;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", {
        name: fieldName,
        className: className,
        rows: rows,
        cols: cols,
        defaultValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_forms__["a" /* decodeFormValue */])(fieldValue),
        onChange: countShow ? this.checkInput : undefined,
        maxLength: countLimit,
        ref: this.textareaRef
      }), countShow && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "textarea-character-count"
      }, count, "/", countLimit));
    }
  }]);

  return LimitedTextarea;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LimitedTextarea.propTypes = {
  fieldName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  fieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cols: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  countShow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  countLimit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
LimitedTextarea.defaultProps = {
  className: 'textarea form-control',
  fieldValue: '',
  rows: 10,
  cols: 40,
  countShow: false,
  countLimit: 2000
};
/* harmony default export */ __webpack_exports__["a"] = (LimitedTextarea);

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProjectFundsElement__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_forms__ = __webpack_require__(153);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }







var ProjectFunds = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectFunds, _React$Component);

  var _super = _createSuper(ProjectFunds);

  function ProjectFunds(props) {
    var _this;

    _classCallCheck(this, ProjectFunds);

    _this = _super.call(this, props);
    var initialState = {};
    var initialValue = props.fieldValue && JSON.parse(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_forms__["a" /* decodeFormValue */])(props.fieldValue));

    if (initialValue && Object.keys(initialValue).length) {
      initialState.elementDatas = initialValue;
    } else if (props.requiredElementDescription) {
      initialState.elementDatas = {
        0: ProjectFunds.createElementData(props.requiredElementDescription, String(props.requiredElementDefault), true)
      };
    } else {
      initialState.elementDatas = {
        0: ProjectFunds.createElementData()
      };
    }

    _this.state = initialState;
    return _this;
  }

  _createClass(ProjectFunds, [{
    key: "onChange",
    value: function onChange(e, order, key) {
      e.preventDefault();
      var oldElementData = this.state.elementDatas[order];

      var newElementData = _objectSpread({}, oldElementData);

      var newValue = e.target.value;

      if (key === 'description') {
        // Allow only one element with requiredElementDescription (created in constructor)
        if (newValue === this.props.requiredElementDescription) return; // Don't allow changing the required elements description

        if (newElementData.required) return;
        newElementData.description = newValue;
      } else if (key === 'amount') {
        var maxAmount = ProjectFunds.MAX_AMOUNT;

        if (newElementData.required) {
          maxAmount = this.props.requiredElementDefault;
        } // Try converting to a positive integer and keep under max


        if (newValue) {
          newValue = String(Math.abs(Math.round(Number(newValue))));

          if (newValue > maxAmount) {
            newValue = String(maxAmount);
          }
        }

        newElementData.amount = newValue;
      }

      this.setState({
        elementDatas: _objectSpread(_objectSpread({}, this.state.elementDatas), {}, _defineProperty({}, order, newElementData))
      });
    }
  }, {
    key: "getTotal",
    value: function getTotal() {
      return Math.round(Object.values(this.state.elementDatas).reduce(function (total, elementData) {
        return total + Number(elementData.amount);
      }, 0));
    }
  }, {
    key: "generateJSON",
    value: function generateJSON() {
      // Convert all numbers to number types and do basic filtering
      var cleanedData = {};
      Object.entries(this.state.elementDatas).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            order = _ref2[0],
            elementData = _ref2[1];

        if (ProjectFunds.elementDataNotEmpty(elementData)) {
          cleanedData[order] = {
            description: elementData.description,
            amount: Math.round(Number(elementData.amount))
          };

          if (elementData.required) {
            cleanedData[order].required = true;
          }
        }
      });
      return JSON.stringify(cleanedData);
    }
  }, {
    key: "canAddElement",
    value: function canAddElement() {
      return Object.keys(this.state.elementDatas).length < this.props.maxElements;
    }
  }, {
    key: "addElement",
    value: function addElement() {
      if (!this.canAddElement()) {
        return;
      }

      var newOrder = String(Math.max.apply(Math, _toConsumableArray(Object.keys(this.state.elementDatas).map(Number))) + 1);
      var newElementData = ProjectFunds.createElementData();
      this.setState({
        elementDatas: _objectSpread(_objectSpread({}, this.state.elementDatas), {}, _defineProperty({}, newOrder, newElementData))
      });
    }
  }, {
    key: "removeElement",
    value: function removeElement(order) {
      // Don't allow removing required elements
      if (this.state.elementDatas[order].required) {
        return;
      } // Don't allow deleting all elements


      if (Object.keys(this.state.elementDatas).length <= 1) {
        return;
      }

      var _this$state$elementDa = this.state.elementDatas,
          _removedElement = _this$state$elementDa[order],
          newElementDatas = _objectWithoutProperties(_this$state$elementDa, [order].map(_toPropertyKey));

      this.setState({
        elementDatas: newElementDatas
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var sortedOrders = Object.keys(this.state.elementDatas).map(Number).sort(function (a, b) {
        return a - b;
      }) // Sort numerically not alphabetically
      .map(String);
      var sortedElementDatas = sortedOrders.map(function (order) {
        return _objectSpread(_objectSpread({}, _this2.state.elementDatas[order]), {}, {
          order: order
        });
      });
      var onlyOneElementData = sortedOrders.length === 1;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "project-funds"
      }, sortedElementDatas.map(function (elementData) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProjectFundsElement__["a" /* default */], {
          key: elementData.order,
          description: elementData.description,
          amount: elementData.amount,
          order: elementData.order,
          onChange: function onChange() {
            return _this2.onChange.apply(_this2, arguments);
          },
          removeElement: function removeElement(order) {
            return _this2.removeElement(order);
          },
          lockDescription: elementData.required,
          canDelete: !(elementData.required || onlyOneElementData),
          maxAmount: elementData.required ? _this2.props.requiredElementDefault : ProjectFunds.MAX_AMOUNT
        });
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "project-funds__element"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "mt-1"
      }, this.canAddElement() && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        type: "button",
        className: "text-btn text-btn--underlined",
        onClick: function onClick() {
          return _this2.addElement();
        }
      }, "+ ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_text__["a" /* gettext */])('Add more')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "mt-1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_text__["a" /* gettext */])('Total'), ":"), "\xA0", this.getTotal(), ",-")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "hidden",
        name: this.props.fieldName,
        value: this.generateJSON()
      }));
    }
  }], [{
    key: "createElementData",
    value: // Keep the numbers somewhat reasonable
    function createElementData() {
      var description = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
      var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var elementData = {
        description: description,
        amount: amount
      };

      if (required) {
        elementData.required = true;
      }

      return elementData;
    }
  }, {
    key: "elementDataNotEmpty",
    value: function elementDataNotEmpty(elementData) {
      return elementData.required || elementData.description && Number(elementData.amount) >= 1;
    }
  }]);

  return ProjectFunds;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ProjectFunds.propTypes = {
  fieldName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  requiredElementDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  requiredElementDefault: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  maxElements: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  fieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
ProjectFunds.defaultProps = {
  requiredElementDescription: undefined,
  requiredElementDefault: 0,
  maxElements: 25,
  fieldValue: undefined
};
ProjectFunds.MAX_AMOUNT = 1000000000;
/* harmony default export */ __webpack_exports__["a"] = (ProjectFunds);

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_text__ = __webpack_require__(4);





var ProjectFundsElement = function ProjectFundsElement(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "project-funds__element"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "text",
    className: "project-funds__description form-control mt-1",
    placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_text__["a" /* gettext */])('Description'),
    value: props.description,
    onChange: function onChange(e) {
      return props.onChange(e, props.order, 'description');
    },
    readOnly: props.lockDescription
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('mt-1', {
      'input-group': props.canDelete
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "number",
    className: "project-funds__amount form-control",
    placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_text__["a" /* gettext */])('Description'),
    value: props.amount,
    onChange: function onChange(e) {
      return props.onChange(e, props.order, 'amount');
    },
    min: 0,
    step: 10,
    max: props.maxAmount
  }), props.canDelete && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: "btn btn-danger",
    onClick: function onClick() {
      return props.removeElement(props.order);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "icon icon--cross"
  })))));
};

ProjectFundsElement.propTypes = {
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,
  order: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  removeElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lockDescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // Lock description
  canDelete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  maxAmount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
ProjectFundsElement.defaultProps = {
  lockDescription: false,
  canDelete: true,
  maxAmount: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (ProjectFundsElement);

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaIconBar__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ducks_arena__ = __webpack_require__(52);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }








var mapStateToProps = function mapStateToProps(state) {
  return {
    mediaCacheId: state.mediaCacheId,
    items: state.items,
    pageSpecificItems: state.pageSpecificItems
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadPageSpecificItems: function loadPageSpecificItems(mediaId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ducks_arena__["j" /* loadPageSpecificItems */])(mediaId));
    }
  };
};

var ArenaBarStandaloneWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ArenaBarStandaloneWrapper, _Component);

  var _super = _createSuper(ArenaBarStandaloneWrapper);

  function ArenaBarStandaloneWrapper() {
    _classCallCheck(this, ArenaBarStandaloneWrapper);

    return _super.apply(this, arguments);
  }

  _createClass(ArenaBarStandaloneWrapper, [{
    key: "componentDidMount",
    value: // We don't know the mediaCacheId for this item at initialization time
    function componentDidMount() {
      // Load Media Cache Item for this media ID
      this.props.loadPageSpecificItems(this.props.initialItem.id);
    }
  }, {
    key: "render",
    value: function render() {
      var item;

      if (this.props.mediaCacheId) {
        item = this.props.pageSpecificItems[this.props.mediaCacheId];
      } else {
        item = this.props.initialItem;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaIconBar__["a" /* default */], {
        item: item,
        commentsLink: this.props.commentsLink || "".concat(this.props.initialItem.link, "#comments")
      });
    }
  }]);

  return ArenaBarStandaloneWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  mediaCacheId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  pageSpecificItems: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_utils_shapes__["d" /* MediaCacheShape */]).isRequired,
  // loaded from DJ_CONST in routeMap.js
  initialItem: __WEBPACK_IMPORTED_MODULE_1_utils_shapes__["k" /* MediaItemShape */].isRequired,
  // overrideable
  commentsLink: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  loadPageSpecificItems: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
}, _class2.defaultProps = {
  mediaCacheId: null,
  commentsLink: null
}, _temp)) || _class);
/* harmony default export */ __webpack_exports__["a"] = (ArenaBarStandaloneWrapper);

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_arena_ArenaIcon__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_arena__ = __webpack_require__(52);






var ArenaFavouriteItem = function ArenaFavouriteItem(_ref) {
  var itemId = _ref.itemId,
      number = _ref.number,
      favouriteItemList = _ref.favouriteItemList,
      toggleFavourite = _ref.toggleFavourite;
  return (
    /*#__PURE__*/
    // eslint-disable-line
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_arena_ArenaIcon__["a" /* default */], {
      iconName: favouriteItemList.includes(itemId) ? 'heart--filled' : 'heart',
      number: number,
      onClick: toggleFavourite,
      className: "icon--interactive"
    })
  );
};

ArenaFavouriteItem.propTypes = {
  itemId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  favouriteItemList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number).isRequired,
  toggleFavourite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    favouriteItemList: state.favouriteItemList
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    toggleFavourite: function toggleFavourite() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ducks_arena__["h" /* toggleFavourite */])(ownProps.itemId));
    }
  };
};

var ArenaFavouriteItemConnected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(mapStateToProps, mapDispatchToProps)(ArenaFavouriteItem);
/* harmony default export */ __webpack_exports__["a"] = (ArenaFavouriteItemConnected);

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ducks_arena__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ArenaBase__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_urls__ = __webpack_require__(21);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }










var mapStateToProps = function mapStateToProps(state) {
  return {
    query: state.query,
    ordering: state.ordering,
    filterChoices: state.choices,
    selectedFilterKey: state.filterKey
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    search: function search(query) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ducks_arena__["m" /* search */])(query));
    },
    sort: function sort(value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ducks_arena__["n" /* sort */])(value));
    }
  };
};

var ArenaHeader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_ArenaBase) {
  _inherits(ArenaHeader, _ArenaBase);

  var _super = _createSuper(ArenaHeader);

  function ArenaHeader() {
    var _this;

    _classCallCheck(this, ArenaHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      query: ''
    };
    return _this;
  }

  _createClass(ArenaHeader, [{
    key: "render",
    value: function render() {
      var buttonUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_urls__["b" /* default */])('trafo_arena_media_add');
      var buttonText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_text__["a" /* gettext */])('Upload');
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__header__title"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_text__["a" /* gettext */])('Explore works'))), this.renderSort(__WEBPACK_IMPORTED_MODULE_4_ducks_arena__["l" /* ORDERING_CHOICES */].choices), this.renderSearch(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: "btn btn-primary mb-0 border-0",
        href: buttonUrl
      }, buttonText));
    }
  }]);

  return ArenaHeader;
}(__WEBPACK_IMPORTED_MODULE_6_components_ArenaBase__["a" /* default */]), _class2.propTypes = {
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  ordering: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  sort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  filterChoices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_utils_shapes__["c" /* FilterChoiceShape */]).isRequired,
  selectedFilterKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}, _temp)) || _class);
/* harmony default export */ __webpack_exports__["a"] = (ArenaHeader);

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_arena_ArenaIconBar__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_arena_ArenaItemPreview__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_text__ = __webpack_require__(4);









var ArenaMediaItem = function ArenaMediaItem(_ref) {
  var item = _ref.item,
      actionCallbackFactory = _ref.actionCallbackFactory,
      actionClassNames = _ref.actionClassNames,
      dispatch = _ref.dispatch;

  var _ref2 = actionCallbackFactory ? actionCallbackFactory(item, {
    dispatch: dispatch
  }) : {},
      actionCallback = _ref2.actionCallback,
      actionLabel = _ref2.actionLabel;

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: item.link
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_lazyload___default.a, {
    height: item.content_preview.height,
    once: true
  }, item.is_talent && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__label"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils_text__["a" /* gettext */])('Trafotalent')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_arena_ArenaItemPreview__["a" /* default */], {
    title: item.title,
    type: item.type,
    itemContent: item.content_preview
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__meta"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: item.link
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
    className: "arena__item__title mb-0"
  }, item.title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("time", {
    className: "arena__item__time"
  }, item.created_at)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__bottom"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__bottom__left"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: item.user.link
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__author"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "arena__item__author__image",
    alt: "",
    src: item.user.avatar_url
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, item.user.name)))), actionCallbackFactory && actionLabel ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    onClick: actionCallback,
    className: actionClassNames
  }, actionLabel) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_arena_ArenaIconBar__["a" /* default */], {
    item: item,
    commentsLink: "".concat(item.link, "#comments")
  }))));
};

ArenaMediaItem.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_4_utils_shapes__["d" /* MediaCacheShape */].isRequired,
  actionCallbackFactory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  actionClassNames: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
ArenaMediaItem.defaultProps = {
  actionCallbackFactory: null,
  actionClassNames: 'btn btn-primary btn-xs mb-2'
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null, mapDispatchToProps)(ArenaMediaItem));

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeAddAndRemoveFromProjectCallbackFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaFilter__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_arena_Arena__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_arena__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_text__ = __webpack_require__(4);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }










var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setChoices: function setChoices(choices) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ducks_arena__["b" /* setChoices */])(choices));
    },
    loadFavourites: function loadFavourites() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ducks_arena__["c" /* loadFavourites */])());
    }
  };
};

var makeAddAndRemoveFromProjectCallbackFactory = function makeAddAndRemoveFromProjectCallbackFactory(_ref) {
  var projectId = _ref.projectId,
      user = _ref.user,
      isParticipant = _ref.isParticipant,
      projectIsActive = _ref.projectIsActive;
  return function (item, _ref2) {
    var dispatch = _ref2.dispatch;
    var hasItemAccess = user && item.user && item.user.id && user.id === item.user.id;

    if (hasItemAccess && item.projects.indexOf(projectId) !== -1) {
      return {
        actionCallback: function actionCallback() {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ducks_arena__["d" /* removeMediaFromProject */])({
            item: item,
            projectId: projectId
          }));
        },
        actionLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils_text__["a" /* gettext */])('Remove from project')
      };
    } else if (isParticipant && hasItemAccess && projectIsActive) {
      return {
        actionCallback: function actionCallback() {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ducks_arena__["e" /* addMediaToProject */])({
            item: item,
            projectId: projectId
          }));
        },
        actionLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils_text__["a" /* gettext */])('Add to project')
      };
    } else {
      return {};
    }
  };
};
var ArenaPreconfiguredWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, mapDispatchToProps), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ArenaPreconfiguredWrapper, _Component);

  var _super = _createSuper(ArenaPreconfiguredWrapper);

  function ArenaPreconfiguredWrapper() {
    var _this;

    _classCallCheck(this, ArenaPreconfiguredWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          filterChoices = _this$props.filterChoices,
          selectedFilterKey = _this$props.selectedFilterKey; // Load favourites

      _this.props.loadFavourites(); // Set filter choices


      _this.props.setChoices({
        choices: filterChoices,
        filterKey: selectedFilterKey
      });
    };

    return _this;
  }

  _createClass(ArenaPreconfiguredWrapper, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          actionCallbackFactory = _this$props2.actionCallbackFactory,
          excludeItem = _this$props2.excludeItem;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaFilter__["a" /* default */], {
        setTitle: false,
        noFlex: true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_arena_Arena__["a" /* default */], {
        actionCallbackFactory: actionCallbackFactory,
        excludeItem: excludeItem
      }));
    }
  }]);

  return ArenaPreconfiguredWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  setChoices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  loadFavourites: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  filterChoices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_utils_shapes__["c" /* FilterChoiceShape */].isRequired).isRequired,
  selectedFilterKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  actionCallbackFactory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  excludeItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}, _class2.defaultProps = {
  actionCallbackFactory: null,
  excludeItem: null
}, _temp)) || _class);
/* harmony default export */ __webpack_exports__["a"] = (ArenaPreconfiguredWrapper);

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_urls__ = __webpack_require__(21);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






var ArenaUploadNewMediaItem = function ArenaUploadNewMediaItem(_ref) {
  var extraQueryParams = _ref.extraQueryParams;
  var extraGetParamsString = extraQueryParams === {} ? '' : '?' + Object.entries(extraQueryParams).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return "".concat(key, "=").concat(value);
  }).join('&');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "arena__item__upload"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "m-3"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('You can upload new artwork to use it here')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_urls__["b" /* default */])('trafo_arena_media_add') + extraGetParamsString,
    className: "btn btn-primary m-3"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('Upload'))));
};

ArenaUploadNewMediaItem.propTypes = {
  extraQueryParams: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};
ArenaUploadNewMediaItem.defaultProps = {
  extraQueryParams: {}
};
/* harmony default export */ __webpack_exports__["a"] = (ArenaUploadNewMediaItem);

/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaHeader__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_arena_ArenaFilter__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_arena_Arena__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ducks_arena__ = __webpack_require__(52);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }










var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setFilters: function setFilters(filters) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_ducks_arena__["k" /* setFilters */])(filters));
    },
    loadFavourites: function loadFavourites() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_ducks_arena__["c" /* loadFavourites */])());
    }
  };
};

var ArenaWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, mapDispatchToProps), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ArenaWrapper, _Component);

  var _super = _createSuper(ArenaWrapper);

  function ArenaWrapper() {
    var _this;

    _classCallCheck(this, ArenaWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          filterChoices = _this$props.filterChoices,
          selectedFilterKey = _this$props.selectedFilterKey,
          selectedOrdering = _this$props.selectedOrdering,
          query = _this$props.query;
      var filters = {
        query: query,
        choices: filterChoices
      }; // If media type was set in the URL and it is a valid media type
      // if not, try setting if to All
      // if even that fails, get first filter available

      if (selectedFilterKey && filterChoices.find(function (filter) {
        return filter.key === selectedFilterKey;
      })) {
        filters.filterKey = selectedFilterKey;
      } else if (filterChoices.find(function (filter) {
        return filter.key === 'all';
      })) {
        filters.filterKey = 'all';
      } else {
        filters.filterKey = filterChoices[0].key;
      } // If ordering was set in the URL and it is a valid ordering key


      if (__WEBPACK_IMPORTED_MODULE_7_ducks_arena__["l" /* ORDERING_CHOICES */].choices.map(function (k) {
        return k.value;
      }).includes(selectedOrdering)) {
        filters.ordering = selectedOrdering;
      } else {
        filters.ordering = __WEBPACK_IMPORTED_MODULE_7_ducks_arena__["l" /* ORDERING_CHOICES */].default;
      } // Load favourites


      _this.props.loadFavourites(); // Set all filters in single action


      _this.props.setFilters(filters);
    };

    return _this;
  }

  _createClass(ArenaWrapper, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_arena_ArenaHeader__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_arena_ArenaFilter__["a" /* default */], {
        setTitle: true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_arena_Arena__["a" /* default */], null));
    }
  }]);

  return ArenaWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  setFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  loadFavourites: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  filterChoices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_utils_shapes__["c" /* FilterChoiceShape */].isRequired).isRequired,
  selectedFilterKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  selectedOrdering: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}, _temp)) || _class);
/* harmony default export */ __webpack_exports__["a"] = (ArenaWrapper);

/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CSRFToken__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_inputs_Select__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_inputs_NonFieldErrors__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_inputs_FieldErrors__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UploadWorkMedia__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UploadWorkMediaPreview__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UploadWorkText__ = __webpack_require__(230);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable no-underscore-dangle */













var initialValues = {
  title: '',
  comment: '',
  workType: 'media',
  media: null,
  text: '',
  text_align: 'left',
  text_font: 'sans-small',
  text_lineheight: 'medium'
};
var initialState = {
  file: null,
  filesAreBeingUploaded: false,
  fileIsBeingDeleted: false,
  previewingText: false,
  errorMessage: null,
  values: initialValues
};

var EditWork = /*#__PURE__*/function (_React$Component) {
  _inherits(EditWork, _React$Component);

  var _super = _createSuper(EditWork);

  function EditWork() {
    var _this;

    _classCallCheck(this, EditWork);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = _objectSpread(_objectSpread({}, initialState), {}, {
      values: _objectSpread(_objectSpread({}, initialValues), _this.props.initialValues || {})
    });

    _this.onDrop = function (acceptedFiles, rejectedFiles) {
      if (acceptedFiles.length > 0) {
        var acceptedFile = acceptedFiles[0];

        _this.uploadFile(acceptedFile);
      }

      if (acceptedFiles.length > 1) {
        _this.setState({
          errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('You can only upload one work at a time.')
        });
      }

      if (rejectedFiles.length > 0) {
        _this.setState({
          errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('Some of the file(s) you uploaded were rejected because of their type')
        });
      }
    };

    _this.deleteMedia = function () {
      if (!_this.state.values.media || _this.state.fileIsBeingDeleted) return;

      if (_this.state.file) {
        window.URL.revokeObjectURL(_this.state.file);
      }

      _this.setState({
        fileIsBeingDeleted: true
      });

      __WEBPACK_IMPORTED_MODULE_6_utils_api__["a" /* default */].mediaDelete.post({
        pk: _this.state.values.media.id
      }).then(function () {
        _this.setState(_objectSpread(_objectSpread({}, initialState), {}, {
          values: _objectSpread(_objectSpread({}, initialValues), {}, {
            workType: _this.state.values.workType // Keep selected workType

          })
        }));
      }).finally(function () {
        _this.setState({
          fileIsBeingDeleted: false
        });
      });
    };

    _this.handleChange = function (e) {
      var name = e.target.name;
      var value = e.target.value;

      _this.setState(function (currentState) {
        return {
          values: _objectSpread(_objectSpread({}, currentState.values), {}, _defineProperty({}, name, value))
        };
      });
    };

    _this.toggleTextPreview = function () {
      _this.setState(function (currentState) {
        return {
          previewingText: !currentState.previewingText
        };
      });
    };

    return _this;
  }

  _createClass(EditWork, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Revoke preview to avoid memory leaks
      if (this.state.file) {
        window.URL.revokeObjectURL(this.state.file);
      }
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file) {
      var _this2 = this;

      this.setState({
        filesAreBeingUploaded: true
      });
      var data = {
        unpublished: true
      };
      var attachment = {
        field: 'files',
        file: file,
        name: file.name
      };
      __WEBPACK_IMPORTED_MODULE_6_utils_api__["a" /* default */].mediaUploadPrivate.post(null, data, null, [attachment]).then(function (result) {
        var response = typeof result === 'string' ? JSON.parse(result) : result;

        if (response.success) {
          var mediaItem = response.uploads[0];

          _this2.setState(function (currentState) {
            return {
              file: file,
              values: _objectSpread(_objectSpread({}, currentState.values), {}, {
                media: mediaItem
              })
            };
          });
        } else {
          var name = file.name;
          var reason = result.error ? result.error : '';

          _this2.setState({
            errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])("File upload failed for file ".concat(name, ". ").concat(reason))
          });
        }
      }).finally(function () {
        _this2.setState({
          filesAreBeingUploaded: false
        });
      });
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      if (this.state.values.workType === 'media') {
        if (!this.state.values.media) return false;
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var content = null;

      if (this.state.values.workType === 'media') {
        content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UploadWorkMediaPreview__["a" /* default */], {
          file: this.state.file,
          media: this.state.values.media,
          title: this.state.values.title,
          comment: this.state.values.comment,
          errors: this.props.errors,
          withDelete: false,
          handleChange: this.handleChange,
          onDelete: this.deleteMedia
        });
      } else if (this.state.values.workType === 'text') {
        content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__UploadWorkText__["a" /* default */], {
          values: this.state.values,
          errors: this.props.errors,
          previewingText: this.state.previewingText,
          textAlignOptions: this.props.textAlignOptions,
          textFontOptions: this.props.textFontOptions,
          textLineheightOptions: this.props.textLineheightOptions,
          withSubtitle: false,
          handleChange: this.handleChange,
          toggleTextPreview: this.toggleTextPreview
        });
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "upload-work"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        method: "post",
        noValidate: "noValidate"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CSRFToken__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_inputs_FieldErrors__["a" /* default */], {
        error: this.props.errors.workType
      }), content, this.state.errorMessage && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "alert alert-danger"
      }, this.state.errorMessage), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_inputs_NonFieldErrors__["a" /* default */], {
        error: this.props.errors.__all__
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: "btn btn-secondary mt-4",
        href: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils_urls__["b" /* default */])('trafo_arena_media_details', this.props.objectId)
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('Cancel')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "btn btn-primary mt-4 ml-3 mr-3",
        name: "action",
        type: "submit",
        disabled: !this.canSubmit()
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('Edit')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: "btn btn-secondary mt-4",
        href: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils_urls__["b" /* default */])('trafo_arena_media_delete', this.props.objectId)
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('Delete'))));
    }
  }]);

  return EditWork;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EditWork.propTypes = {
  objectId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  textAlignOptions: __WEBPACK_IMPORTED_MODULE_7_utils_shapes__["l" /* SelectOptionsShape */].isRequired,
  textFontOptions: __WEBPACK_IMPORTED_MODULE_7_utils_shapes__["l" /* SelectOptionsShape */].isRequired,
  textLineheightOptions: __WEBPACK_IMPORTED_MODULE_7_utils_shapes__["l" /* SelectOptionsShape */].isRequired,
  privacyOptions: __WEBPACK_IMPORTED_MODULE_7_utils_shapes__["l" /* SelectOptionsShape */].isRequired,
  initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    comment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    workType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  errors: __WEBPACK_IMPORTED_MODULE_7_utils_shapes__["a" /* ErrorsShape */]
};
EditWork.defaultProps = {
  accept: undefined,
  initialValues: {},
  errors: {}
};
/* harmony default export */ __webpack_exports__["a"] = (EditWork);

/***/ }),

/***/ 517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RadioButton__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UploadWorkMedia__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UploadWorkMediaPreview__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CSRFToken__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inputs_NonFieldErrors__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inputs_FieldErrors__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UploadWorkText__ = __webpack_require__(230);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable no-underscore-dangle */













var UploadWork = /*#__PURE__*/function (_React$Component) {
  _inherits(UploadWork, _React$Component);

  var _super = _createSuper(UploadWork);

  function UploadWork(props) {
    var _this;

    _classCallCheck(this, UploadWork);

    _this = _super.call(this, props);

    var initialState = _objectSpread({}, UploadWork.emptyState);

    if (Object.keys(props.initialValues).length > 0) {
      initialState.values = _objectSpread(_objectSpread({}, initialState.values), props.initialValues);
    }

    _this.state = initialState;
    return _this;
  }

  _createClass(UploadWork, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Revoke preview to avoid memory leaks
      if (this.state.file) {
        window.URL.revokeObjectURL(this.state.file);
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop(acceptedFiles, rejectedFiles) {
      if (acceptedFiles.length > 0) {
        var acceptedFile = acceptedFiles[0];
        this.uploadFile(acceptedFile);
      }

      if (acceptedFiles.length > 1) {
        this.setState({
          errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('You can only upload one work at a time.')
        });
      }

      if (rejectedFiles.length > 0) {
        this.setState({
          errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Some of the file(s) you uploaded were rejected because of their type')
        });
      }
    }
  }, {
    key: "deleteMedia",
    value: function deleteMedia() {
      var _this2 = this;

      if (!this.state.values.media || this.state.fileIsBeingDeleted) return;

      if (this.state.file) {
        window.URL.revokeObjectURL(this.state.file);
      }

      this.setState({
        fileIsBeingDeleted: true
      });
      __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].mediaDelete.post({
        pk: this.state.values.media.id
      }).then(function () {
        _this2.setState(_objectSpread(_objectSpread({}, UploadWork.emptyState), {}, {
          values: _objectSpread(_objectSpread({}, UploadWork.emptyState.values), {}, {
            workType: _this2.state.values.workType // Keep selected workType

          })
        }));
      }).finally(function () {
        _this2.setState({
          fileIsBeingDeleted: false
        });
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var name = e.target.name;
      var value = e.target.value;
      this.setState(function (currentState) {
        return {
          values: _objectSpread(_objectSpread({}, currentState.values), {}, _defineProperty({}, name, value))
        };
      });
    }
  }, {
    key: "toggleTextPreview",
    value: function toggleTextPreview() {
      this.setState(function (currentState) {
        return {
          previewingText: !currentState.previewingText
        };
      });
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(file) {
      var _this3 = this;

      this.setState({
        filesAreBeingUploaded: true
      });
      var data = {
        unpublished: true
      };
      var attachment = {
        field: 'files',
        file: file,
        name: file.name
      };
      __WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* default */].mediaUploadPrivate.post(null, data, null, [attachment]).then(function (result) {
        var response = typeof result === 'string' ? JSON.parse(result) : result;

        if (response.success) {
          var mediaItem = response.uploads[0];

          _this3.setState(function (currentState) {
            return {
              file: file,
              values: _objectSpread(_objectSpread({}, currentState.values), {}, {
                media: mediaItem
              })
            };
          });
        } else {
          var name = file.name;
          var reason = result.error ? result.error : '';

          _this3.setState({
            errorMessage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])("File upload failed for file ".concat(name, ". ").concat(reason))
          });
        }
      }).finally(function () {
        _this3.setState({
          filesAreBeingUploaded: false
        });
      });
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      if (this.state.values.workType === 'media') {
        if (!this.state.values.media) return false;
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var content = '';

      if (this.state.values.workType === 'media') {
        if (this.state.file || this.state.values.media) {
          content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UploadWorkMediaPreview__["a" /* default */], {
            file: this.state.file,
            media: this.state.values.media,
            title: this.state.values.title,
            comment: this.state.values.comment,
            errors: this.props.errors,
            handleChange: function handleChange(e) {
              return _this4.handleChange(e);
            },
            onDelete: function onDelete() {
              return _this4.deleteMedia();
            }
          });
        } else {
          content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UploadWorkMedia__["a" /* default */], {
            filesAreBeingUploaded: this.state.filesAreBeingUploaded,
            accept: this.props.accept,
            onDrop: function onDrop() {
              return _this4.onDrop.apply(_this4, arguments);
            }
          });
        }
      } else if (this.state.values.workType === 'text') {
        content = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UploadWorkText__["a" /* default */], {
          values: this.state.values,
          errors: this.props.errors,
          previewingText: this.state.previewingText,
          textAlignOptions: this.props.textAlignOptions,
          textFontOptions: this.props.textFontOptions,
          textLineheightOptions: this.props.textLineheightOptions,
          handleChange: function handleChange(e) {
            return _this4.handleChange(e);
          },
          toggleTextPreview: function toggleTextPreview() {
            return _this4.toggleTextPreview();
          }
        });
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "upload-work"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        method: "post",
        noValidate: "noValidate"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CSRFToken__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RadioButton__["a" /* default */], {
        id: "radio-work-type-media",
        name: "workType",
        value: "media",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Media'),
        checked: this.state.values.workType === 'media',
        onChange: function onChange(e) {
          return _this4.handleChange(e);
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RadioButton__["a" /* default */], {
        id: "radio-work-type-text",
        name: "workType",
        value: "text",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Text'),
        checked: this.state.values.workType === 'text',
        onChange: function onChange(e) {
          return _this4.handleChange(e);
        }
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__inputs_FieldErrors__["a" /* default */], {
        error: this.props.errors.workType
      }), content, this.state.errorMessage && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "alert alert-danger"
      }, this.state.errorMessage), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__inputs_NonFieldErrors__["a" /* default */], {
        error: this.props.errors.__all__
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "btn btn-primary mt-4",
        type: "submit",
        disabled: !this.canSubmit()
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_text__["a" /* gettext */])('Upload work'))));
    }
  }]);

  return UploadWork;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

UploadWork.propTypes = {
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  textAlignOptions: __WEBPACK_IMPORTED_MODULE_8__utils_shapes__["l" /* SelectOptionsShape */].isRequired,
  textFontOptions: __WEBPACK_IMPORTED_MODULE_8__utils_shapes__["l" /* SelectOptionsShape */].isRequired,
  textLineheightOptions: __WEBPACK_IMPORTED_MODULE_8__utils_shapes__["l" /* SelectOptionsShape */].isRequired,
  initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    comment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    workType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  errors: __WEBPACK_IMPORTED_MODULE_8__utils_shapes__["a" /* ErrorsShape */]
};
UploadWork.defaultProps = {
  accept: undefined,
  initialValues: {},
  errors: {}
};
UploadWork.emptyState = {
  values: {
    title: '',
    comment: '',
    workType: 'media',
    media: null,
    text: '',
    text_align: 'left',
    text_font: 'sans-small',
    text_lineheight: 'medium'
  },
  file: null,
  filesAreBeingUploaded: false,
  fileIsBeingDeleted: false,
  previewingText: false,
  errorMessage: null
};
/* harmony default export */ __webpack_exports__["a"] = (UploadWork);

/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_assets__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_urls__ = __webpack_require__(21);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }









var SliderArrow = function SliderArrow(props) {
  var className = props.className,
      onClick = props.onClick;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: className,
    onClick: onClick
  }) // eslint-disable-line jsx-a11y/anchor-has-content
  ;
};

SliderArrow.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
SliderArrow.defaultProps = {
  className: '',
  onClick: function onClick() {
    return null;
  }
};

var BgSlider = function BgSlider(_ref) {
  var images = _ref.images,
      periodUntil = _ref.periodUntil,
      theme = _ref.theme;
  var buttons = [];

  if (periodUntil) {
    buttons.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      key: "fundingbtn",
      className: "btn-caption-group mr-3"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_utils_urls__["b" /* default */])('trafo_fundingapplication_start'),
      className: "btn btn-primary"
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_text__["a" /* gettext */])('Apply for 10 000,-')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "btn-caption btn-caption--".concat(theme)
    }, periodUntil, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_text__["a" /* gettext */])('to apply'))));
  }

  buttons.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    key: "mentorbtn",
    href: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_utils_urls__["b" /* default */])('trafo_mentorapplication_start'),
    className: "btn btn-outline-light"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_text__["a" /* gettext */])('Apply for mentorship')));
  var children = images.map(function (img) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      key: "img-".concat(img.order),
      className: "fp-slide"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "fp-slide__content",
      style: {
        backgroundImage: "url(".concat(img.url, ")")
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "container"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "hero__center"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", {
      className: "hero__title"
    }, img.flavour), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "hero__center__buttons"
    }, buttons)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "hero__bottom"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "hero__left"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: "https://www.kulturradet.no/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      src: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_assets__["a" /* resolveStatic */])('images/kulturradet.svg'),
      alt: "kulturradet logo"
    }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "hero__middle"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      id: "scroll-down"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: "#creativity"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
      className: "icon icon--arrow-circle"
    })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "hero__right"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "hero__caption"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "hero__caption__title"
    }, img.title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "hero__caption__author"
    }, img.author)))))));
  });
  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 4000,
    fade: true,
    arrows: false
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_slick___default.a, _extends({}, settings, {
    /* Arrows currently disabled by arrows: false in settings. Keeping the arrows here in case we need to
     * re-enable them later */
    nextArrow: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SliderArrow, null),
    prevArrow: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SliderArrow, null)
  }), children);
};

BgSlider.propTypes = {
  images: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_utils_shapes__["m" /* FPImageShape */]).isRequired,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  periodUntil: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
BgSlider.defaultProps = {
  theme: 'white',
  periodUntil: ''
};
/* harmony default export */ __webpack_exports__["a"] = (BgSlider);

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ducks_memberlist__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ArenaBase__ = __webpack_require__(220);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }









var mapStateToProps = function mapStateToProps(state) {
  return {
    query: state.query,
    ordering: state.ordering,
    filterChoices: state.choices,
    selectedFilterKey: state.filterKey
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    search: function search(query) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ducks_memberlist__["e" /* search */])(query));
    },
    sort: function sort(value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ducks_memberlist__["b" /* sort */])(value));
    }
  };
};

var MemberListHeader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_ArenaBase) {
  _inherits(MemberListHeader, _ArenaBase);

  var _super = _createSuper(MemberListHeader);

  function MemberListHeader() {
    var _this;

    _classCallCheck(this, MemberListHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      query: ''
    };
    return _this;
  }

  _createClass(MemberListHeader, [{
    key: "render",
    value: function render() {
      var isLoggedIn = DJ_CONST.user !== null;
      var buttonUrl = isLoggedIn ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_urls__["b" /* default */])('trafo_application_mentoroverview') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_urls__["b" /* default */])('trafo-register');
      var buttonText = isLoggedIn ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_text__["a" /* gettext */])('Mentors') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_text__["a" /* gettext */])('Join Trafo');
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__header__title"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_text__["a" /* gettext */])('Members'))), this.renderSort(__WEBPACK_IMPORTED_MODULE_3_ducks_memberlist__["c" /* ORDERING_CHOICES */].choices), this.renderSearch(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: "btn btn-primary mb-0 border-0",
        href: buttonUrl
      }, buttonText));
    }
  }]);

  return MemberListHeader;
}(__WEBPACK_IMPORTED_MODULE_6__ArenaBase__["a" /* default */]), _class2.propTypes = {
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  ordering: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  sort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, _temp)) || _class);
/* harmony default export */ __webpack_exports__["a"] = (MemberListHeader);

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ORDERING_CHOICES; });
/* harmony export (immutable) */ __webpack_exports__["a"] = arenaReducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectActiveFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loadItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return loadPageSpecificItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return search; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return sort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setFilterKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setChoices; });
/* unused harmony export setUrlHandling */
/* unused harmony export setFavourites */
/* unused harmony export setFavouriteStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toggleFavourite; });
/* unused harmony export addOrRemoveMediaForProject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeMediaFromProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addMediaToProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadFavourites; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_urls__ = __webpack_require__(21);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }





var history = __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()();
var LOAD_ITEMS = 'arena/LOAD_ITEMS';
var SET_CHOICES = 'arena/SET_CHOICES';
var SET_SEARCH = 'arena/SET_SEARCH';
var SET_ORDERING = 'arena/SET_ORDERING';
var SET_FILTER_KEY = 'arena/SET_FILTER_KEY';
var SET_FILTERS = 'arena/SET_FILTERS';
var SET_URL_HANDLING = 'arena/SET_URL_HANDLING';
var SET_FAVOURITES = 'arena/SET_FAVOURITES';
var SET_FAVOURITE_STATUS = 'arena/SET_FAVOURITE_STATUS';
var SET_MEDIA_IN_PROJECT_STATUS = 'arena/SET_MEDIA_IN_PROJECT_STATUS';
var SET_CACHE_ITEM = 'arena/SET_CACHE_ITEM';
var ORDERING_CHOICES = {
  choices: [{
    value: 'latest',
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('Latest'),
    apiKey: '-media__created_at'
  }, {
    value: 'newandpopular',
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('New and popular'),
    apiKey: '-new_and_popular_weight'
  }, {
    value: 'mostcommented',
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('Most commented'),
    apiKey: '-number_of_public_comments'
  }, {
    value: 'lastcommented',
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('Last commented'),
    apiKey: '-last_public_comment__created_at'
  }],
  default: 'latest'
};
var initialState = {
  items: {},
  itemIds: [],
  // pageSpecificItems do not render in masonry, but are updated when favourites change and provide data
  // to components on the page outside masonry
  pageSpecificItems: {},
  limit: 6,
  choices: [{
    key: 'all',
    filter: {},
    label: 'All'
  }],
  filters: {},
  filterKey: 'all',
  hasMore: true,
  startLoad: true,
  query: '',
  ordering: ORDERING_CHOICES.default,
  // Some places across trafo, get parameters are used for various stuff, so can't really change the URL
  // without harm done, thus adding an option to skip this
  handleUrl: true,
  favouriteItemList: []
};
function arenaReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LOAD_ITEMS:
      {
        var normalizedItems = {};
        var itemIds = action.clear ? [] : _toConsumableArray(state.itemIds);
        action.items.forEach(function (item) {
          normalizedItems[item.id] = item;

          if (!itemIds.includes(item.id)) {
            itemIds.push(item.id);
          }
        });
        var items = action.clear ? normalizedItems : _objectSpread(_objectSpread({}, state.items), normalizedItems);
        return _objectSpread(_objectSpread({}, state), {}, {
          hasMore: action.count > itemIds.length,
          items: items,
          itemIds: itemIds,
          startLoad: false
        });
      }

    case SET_CACHE_ITEM:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          pageSpecificItems: action.pageSpecificItems,
          mediaCacheId: action.mediaCacheId
        });
      }

    case SET_SEARCH:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          query: action.query,
          startLoad: true
        });
      }

    case SET_ORDERING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ordering: action.ordering,
          startLoad: true
        });
      }

    case SET_FILTER_KEY:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          filterKey: action.filterKey,
          ordering: ORDERING_CHOICES.choices.map(function (k) {
            return k.value;
          }).includes(state.ordering) ? state.ordering : ORDERING_CHOICES.default,
          startLoad: true
        });
      }

    case SET_FILTERS:
      {
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.filters), {}, {
          startLoad: true
        });
      }

    case SET_CHOICES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          choices: action.choices,
          filterKey: action.filterKey
        });
      }

    case SET_URL_HANDLING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          handleUrl: action.handle
        });
      }

    case SET_FAVOURITES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          favouriteItemList: action.favouriteItemList
        });
      }

    case SET_FAVOURITE_STATUS:
      {
        var changedItems = {};

        if (action.mediaCacheId in state.items) {
          changedItems = _objectSpread({}, action.items);
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          // Either filter the id out, or add it
          favouriteItemList: action.status ? state.favouriteItemList.concat([action.mediaCacheId]) : state.favouriteItemList.filter(function (mediaCacheId) {
            return mediaCacheId !== action.mediaCacheId;
          }),
          items: _objectSpread(_objectSpread({}, state.items), changedItems),
          pageSpecificItems: _objectSpread(_objectSpread({}, state.pageSpecificItems), action.items)
        });
      }

    case SET_MEDIA_IN_PROJECT_STATUS:
      {
        var mediaCacheId = action.mediaCacheId,
            projectId = action.projectId,
            isInProject = action.isInProject;

        if (!(mediaCacheId in state.items)) {
          return _objectSpread({}, state);
        }

        var filteredProjects = state.items[mediaCacheId].projects.filter(function (id) {
          return id !== projectId;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          items: _objectSpread(_objectSpread({}, state.items), {}, _defineProperty({}, mediaCacheId, _objectSpread(_objectSpread({}, state.items[mediaCacheId]), {}, {
            projects: isInProject ? [].concat(_toConsumableArray(filteredProjects), [projectId]) : filteredProjects
          })))
        });
      }

    default:
      {
        return state;
      }
  }
}

var setItems = function setItems(items, count, clear) {
  return {
    type: LOAD_ITEMS,
    items: items,
    count: count,
    clear: clear
  };
};

var makeUrl = function makeUrl(state) {
  var filterKey = state.filterKey,
      query = state.query,
      ordering = state.ordering;
  var baseUrl = window.location.pathname; // Query parameters to be added to the URL.
  // The keys are parameter names, values are parameter values.

  var queryParams = {
    filter: filterKey,
    query: query,
    ordering: ordering
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_utils_urls__["a" /* buildUrl */])(baseUrl, queryParams);
};

var selectActiveFilters = function selectActiveFilters(_ref) {
  var choices = _ref.choices,
      filterKey = _ref.filterKey;
  return choices.find(function (filter) {
    return filter.key === filterKey;
  }) || choices[0];
};
var loadItems = function loadItems() {
  var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch, getState) {
    var state = getState();
    var itemIds = state.itemIds,
        limit = state.limit,
        query = state.query,
        ordering = state.ordering,
        handleUrl = state.handleUrl;
    var activeFilters = selectActiveFilters(state);
    var apiKey = activeFilters['apiKey'] || 'arena';

    var queryParams = _objectSpread(_objectSpread({
      offset: clear ? 0 : itemIds.length,
      limit: limit,
      query: query
    }, activeFilters.filter), {}, {
      ordering: ORDERING_CHOICES.choices.find(function (k) {
        return k.value === ordering;
      }).apiKey
    });

    __WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */][apiKey].fetch(null, queryParams).then(function (result) {
      dispatch(setItems(result.results, result.count, clear));

      if (handleUrl) {
        var url = makeUrl(state);
        history.replace(url);
      }
    });
  };
};
var loadPageSpecificItems = function loadPageSpecificItems(mediaId) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].arena.fetch(null, {
      media: mediaId
    }).then(function (result) {
      var pageItem = result.results[0];
      dispatch({
        type: SET_CACHE_ITEM,
        pageSpecificItems: _defineProperty({}, pageItem.id, pageItem),
        mediaCacheId: pageItem.id
      });
    });
  };
};
var search = function search(query) {
  return function (dispatch) {
    dispatch({
      type: SET_SEARCH,
      query: query
    });
    dispatch(loadItems(true));
  };
};
var sort = function sort(ordering) {
  return function (dispatch) {
    dispatch({
      type: SET_ORDERING,
      ordering: ordering
    });
    dispatch(loadItems(true));
  };
};
var setFilterKey = function setFilterKey(filterKey) {
  return function (dispatch) {
    dispatch({
      type: SET_FILTER_KEY,
      filterKey: filterKey
    });
    dispatch(loadItems(true));
  };
};
/* Used to initially set filters when the app loads form URL with filters prefilled */

var setFilters = function setFilters(filters) {
  return function (dispatch) {
    dispatch({
      type: SET_FILTERS,
      filters: filters
    });
    dispatch(loadItems(true));
  };
};
var setChoices = function setChoices(choiceInformation) {
  return function (dispatch) {
    dispatch(_objectSpread({
      type: SET_CHOICES
    }, choiceInformation));
    dispatch(loadItems(true));
  };
};
var setUrlHandling = function setUrlHandling(handle) {
  return function (dispatch) {
    dispatch({
      type: SET_URL_HANDLING,
      handle: handle
    });
  };
};
var setFavourites = function setFavourites(favouriteItemList) {
  return function (dispatch) {
    dispatch({
      type: SET_FAVOURITES,
      favouriteItemList: favouriteItemList
    });
  };
};
var setFavouriteStatus = function setFavouriteStatus(_ref2) {
  var mediaCacheId = _ref2.mediaCacheId,
      status = _ref2.status,
      items = _ref2.items;
  return function (dispatch) {
    dispatch({
      type: SET_FAVOURITE_STATUS,
      mediaCacheId: mediaCacheId,
      status: status,
      items: items
    });
  };
};
var toggleFavourite = function toggleFavourite(mediaCacheId) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].toggleFavourite.post({
      mediaCacheId: mediaCacheId
    }).then(function (result) {
      if (result.success) {
        dispatch(setFavouriteStatus({
          mediaCacheId: mediaCacheId,
          status: result.new_favourite_status,
          items: result.items
        }));
      }
    });
  };
};
var addOrRemoveMediaForProject = function addOrRemoveMediaForProject(_ref3) {
  var item = _ref3.item,
      projectId = _ref3.projectId,
      isInProject = _ref3.isInProject;
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].projectMedia.put({
      pk: projectId
    }, _defineProperty({}, isInProject ? 'add_media' : 'remove_media', [item.media])).then(function (result) {
      dispatch({
        type: SET_MEDIA_IN_PROJECT_STATUS,
        mediaCacheId: item.id,
        isInProject: isInProject,
        projectId: projectId
      }); // Filters might cause the item to disappear in new state - trigger reloading for this to work

      dispatch(loadItems(true));
    });
  };
};
var removeMediaFromProject = function removeMediaFromProject(_ref4) {
  var item = _ref4.item,
      projectId = _ref4.projectId;
  return function (dispatch) {
    dispatch(addOrRemoveMediaForProject({
      item: item,
      projectId: projectId,
      isInProject: false
    }));
  };
};
var addMediaToProject = function addMediaToProject(_ref5) {
  var item = _ref5.item,
      projectId = _ref5.projectId;
  return function (dispatch) {
    dispatch(addOrRemoveMediaForProject({
      item: item,
      projectId: projectId,
      isInProject: true
    }));
  };
};
var loadFavourites = function loadFavourites() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].favourites.fetch().then(function (result) {
      dispatch(setFavourites(result.favourites));
    });
  };
};

/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_medlemmer_MemberListHeader__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_medlemmer_MembersView__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_memberlist__ = __webpack_require__(109);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }








var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sort: function sort(ordering) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_ducks_memberlist__["b" /* sort */])(ordering));
    }
  };
};

var MemberWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, mapDispatchToProps), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(MemberWrapper, _Component);

  var _super = _createSuper(MemberWrapper);

  function MemberWrapper() {
    var _this;

    _classCallCheck(this, MemberWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.componentDidMount = function () {
      var selectedOrdering = _this.props.selectedOrdering;
      var ordering = __WEBPACK_IMPORTED_MODULE_5_ducks_memberlist__["c" /* ORDERING_CHOICES */].default; // If ordering was set in the URL and it is a valid ordering key

      if (__WEBPACK_IMPORTED_MODULE_5_ducks_memberlist__["c" /* ORDERING_CHOICES */].choices.map(function (k) {
        return k.value;
      }).includes(selectedOrdering)) {
        ordering = selectedOrdering;
      } // Set all filters in single action


      _this.props.sort(ordering);
    };

    return _this;
  }

  _createClass(MemberWrapper, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_medlemmer_MemberListHeader__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_medlemmer_MembersView__["a" /* default */], null));
    }
  }]);

  return MemberWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  selectedOrdering: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  sort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, _temp)) || _class);
/* harmony default export */ __webpack_exports__["a"] = (MemberWrapper);

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_masonry_css__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_masonry_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_masonry_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_medlemmer_ArenaMemberItem__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_memberlist__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Loading__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_text__ = __webpack_require__(4);











var mapStateToProps = function mapStateToProps(state) {
  return {
    items: state.itemIds.map(function (item) {
      return state.items[item];
    }),
    hasMore: state.hasMore,
    startLoad: state.startLoad
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onLoadItems: function onLoadItems() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ducks_memberlist__["d" /* loadItems */])());
    }
  };
};

var MembersList = function MembersList(_ref) {
  var onLoadItems = _ref.onLoadItems,
      hasMore = _ref.hasMore,
      items = _ref.items,
      startLoad = _ref.startLoad;
  var emptyState = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "jumbotron text-center"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils_text__["a" /* gettext */])('Nothing was found. Choose another category or try searching for something else.'));

  var renderItems = function renderItems() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_infinite_scroller___default.a, {
      initialLoad: false,
      pageStart: 0,
      loadMore: onLoadItems,
      hasMore: hasMore,
      loader: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__loading",
        key: 0
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Loading__["a" /* default */], null))
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_masonry_css___default.a, {
      breakpointCols: {
        default: 3,
        1200: 2,
        768: 1
      },
      className: "arena__masonry",
      columnClassName: "arena__masonry__column"
    }, items.map(function (item) {
      return item ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_medlemmer_ArenaMemberItem__["a" /* default */], {
        key: item.id,
        item: item
      }) : null;
    })));
  };

  if (startLoad) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "jumbotron text-center"
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_utils_text__["a" /* gettext */])('Loading… please wait'));
  }

  return items.length ? renderItems() : emptyState;
};

MembersList.propTypes = {
  onLoadItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  hasMore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_utils_shapes__["e" /* MemberShape */]).isRequired,
  startLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
var MembersView = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(MembersList);
/* harmony default export */ __webpack_exports__["a"] = (MembersView);

/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_mentors_SingleMentor__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_mentorlist__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Loading__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_text__ = __webpack_require__(4);










var mapStateToProps = function mapStateToProps(state) {
  return {
    items: state.itemIds.map(function (item) {
      return state.items[item];
    }),
    hasMore: state.hasMore,
    startLoad: state.startLoad
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onLoadItems: function onLoadItems() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_ducks_mentorlist__["c" /* loadItems */])());
    }
  };
};

var MentorList = function MentorList(_ref) {
  var onLoadItems = _ref.onLoadItems,
      hasMore = _ref.hasMore,
      items = _ref.items,
      startLoad = _ref.startLoad;
  var emptyState = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "jumbotron text-center"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('Nothing was found. Choose another category or try searching for something else.'));

  var renderItems = function renderItems() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller___default.a, {
      className: 'featured',
      initialLoad: false,
      pageStart: 0,
      loadMore: onLoadItems,
      hasMore: hasMore,
      loader: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__loading",
        key: 0
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Loading__["a" /* default */], null))
    }, items.map(function (item) {
      return item ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_mentors_SingleMentor__["a" /* default */], {
        key: item.id,
        mentor: item
      }) : null;
    }));
  };

  if (startLoad) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "jumbotron text-center"
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('Loading… please wait'));
  }

  return items.length ? renderItems() : emptyState;
};

MentorList.propTypes = {
  onLoadItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  hasMore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_utils_shapes__["j" /* MentorShape */]).isRequired,
  startLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
var MentorListConnected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(MentorList);
/* harmony default export */ __webpack_exports__["a"] = (MentorListConnected);

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_RadioButton__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ducks_mentorlist__ = __webpack_require__(110);









var renderHelmet = function renderHelmet(title) {
  var pageTitle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_text__["a" /* gettext */])('Trafo.no, the largest society for young artists in the north');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet__["Helmet"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_text__["a" /* gettext */])('Mentors'), " \u2014 ").concat(title, " \u2014 ").concat(pageTitle)));
};

var MentorListFilter = function MentorListFilter(_ref) {
  var choices = _ref.choices,
      onChange = _ref.onChange,
      selectedFilterKey = _ref.selectedFilterKey,
      setTitle = _ref.setTitle,
      noFlex = _ref.noFlex;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('arena__filter', {
      'arena__filter--noflex': noFlex
    })
  }, setTitle ? renderHelmet(choices.find(function (filter) {
    return filter.key === selectedFilterKey;
  }).label) : null, choices.map(function (filter) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_RadioButton__["a" /* default */], {
      key: filter.key,
      name: "filter",
      value: filter.key,
      id: filter.key,
      label: filter.label,
      onChange: onChange,
      checked: selectedFilterKey === filter.key
    });
  }));
};

MentorListFilter.propTypes = {
  choices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  // eslint-disable-line
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedFilterKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  setTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  noFlex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
MentorListFilter.defaultProps = {
  noFlex: false
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedFilterKey: state.filterKey,
    choices: state.choices
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onChange: function onChange(e) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_ducks_mentorlist__["d" /* setFilterKey */])(e.target.value));
    }
  };
};

var MentorListFilterConnected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(MentorListFilter);
/* harmony default export */ __webpack_exports__["a"] = (MentorListFilterConnected);

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_mentors_MentorListFilter__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_mentors_MentorList__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_mentorlist__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_text__ = __webpack_require__(4);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }











var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setFilters: function setFilters(filters) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ducks_mentorlist__["b" /* setFilters */])(filters));
    }
  };
};

var MentorListWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, mapDispatchToProps), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(MentorListWrapper, _Component);

  var _super = _createSuper(MentorListWrapper);

  function MentorListWrapper() {
    var _this;

    _classCallCheck(this, MentorListWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          filterChoices = _this$props.filterChoices,
          selectedFilterKey = _this$props.selectedFilterKey,
          query = _this$props.query;
      var filters = {
        query: query,
        choices: filterChoices
      }; // If category was set in the URL and it is a valid category codename
      // if not, try setting if to All
      // if even that fails, get first filter available

      if (selectedFilterKey && filterChoices.find(function (filter) {
        return filter.key === selectedFilterKey;
      })) {
        filters.filterKey = selectedFilterKey;
      } else if (filterChoices.find(function (filter) {
        return filter.key === 'all';
      })) {
        filters.filterKey = 'all';
      } else {
        filters.filterKey = filterChoices[0].key;
      } // Set all filters in single action


      _this.props.setFilters(filters);
    };

    return _this;
  }

  _createClass(MentorListWrapper, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__header__title"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_text__["a" /* gettext */])('Mentors'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: "button--apply-mentor btn btn-primary mb-0 border-0",
        href: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_utils_urls__["b" /* default */])('trafo_mentorapplication_add')
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_text__["a" /* gettext */])('Apply for 3 hours of individual mentoring on your project'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_mentors_MentorListFilter__["a" /* default */], {
        setTitle: true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_mentors_MentorList__["a" /* default */], null));
    }
  }]);

  return MentorListWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  setFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  filterChoices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_utils_shapes__["g" /* SimpleFilterChoiceShape */].isRequired).isRequired,
  selectedFilterKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}, _temp)) || _class);
/* harmony default export */ __webpack_exports__["a"] = (MentorListWrapper);

/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Preview__ = __webpack_require__(149);





var SingleMentor = function SingleMentor(_ref) {
  var mentor = _ref.mentor;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Preview__["a" /* default */])({
    url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_urls__["b" /* default */])('trafo_member_profile', {
      pk: mentor.user.id
    }),
    title: mentor.user.name,
    subtitle: mentor.cat.map(function (cat, index) {
      if (index === mentor.cat.length - 1) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          key: cat.id
        }, cat.name);
      } else {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          key: cat.id
        }, cat.name, ", ");
      }
    }),
    description: mentor.info,
    image: mentor.user.avatar_url_medium
  });
};

SingleMentor.propTypes = {
  mentor: __WEBPACK_IMPORTED_MODULE_1_utils_shapes__["j" /* MentorShape */].isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SingleMentor);

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_news_SingleArticle__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_newslist__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Loading__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_text__ = __webpack_require__(4);










var mapStateToProps = function mapStateToProps(state) {
  return {
    items: state.itemIds.map(function (item) {
      return state.items[item];
    }),
    hasMore: state.hasMore,
    startLoad: state.startLoad
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onLoadItems: function onLoadItems() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_ducks_newslist__["c" /* loadItems */])());
    }
  };
};

var NewsList = function NewsList(_ref) {
  var onLoadItems = _ref.onLoadItems,
      hasMore = _ref.hasMore,
      items = _ref.items,
      startLoad = _ref.startLoad;
  var emptyState = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "jumbotron text-center"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('Nothing was found. Choose another category or try searching for something else.'));

  var renderItems = function renderItems() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller___default.a, {
      className: 'featured',
      initialLoad: false,
      pageStart: 0,
      loadMore: onLoadItems,
      hasMore: hasMore,
      loader: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__loading",
        key: 0
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Loading__["a" /* default */], null))
    }, items.map(function (item) {
      return item ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_news_SingleArticle__["a" /* default */], {
        key: item.id,
        article: item
      }) : null;
    }));
  };

  if (startLoad) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "jumbotron text-center"
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('Loading… please wait'));
  }

  return items.length ? renderItems() : emptyState;
};

NewsList.propTypes = {
  onLoadItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  hasMore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_utils_shapes__["h" /* ArticleShape */]).isRequired,
  startLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
var NewsListConnected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(NewsList);
/* harmony default export */ __webpack_exports__["a"] = (NewsListConnected);

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_RadioButton__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ducks_newslist__ = __webpack_require__(111);









var renderHelmet = function renderHelmet(title) {
  var pageTitle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_text__["a" /* gettext */])('Trafo.no, the largest society for young artists in the north');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet__["Helmet"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_utils_text__["a" /* gettext */])('News'), " \u2014 ").concat(title, " \u2014 ").concat(pageTitle)));
};

var NewsListFilter = function NewsListFilter(_ref) {
  var choices = _ref.choices,
      onChange = _ref.onChange,
      selectedFilterKey = _ref.selectedFilterKey,
      setTitle = _ref.setTitle,
      noFlex = _ref.noFlex;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('arena__filter', {
      'arena__filter--noflex': noFlex
    })
  }, setTitle ? renderHelmet(choices.find(function (filter) {
    return filter.key === selectedFilterKey;
  }).label) : null, choices.map(function (filter) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_RadioButton__["a" /* default */], {
      key: filter.key,
      name: "filter",
      value: filter.key,
      id: filter.key,
      label: filter.label,
      onChange: onChange,
      checked: selectedFilterKey === filter.key
    });
  }));
};

NewsListFilter.propTypes = {
  choices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  // eslint-disable-line
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedFilterKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  setTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  noFlex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
NewsListFilter.defaultProps = {
  noFlex: false
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedFilterKey: state.filterKey,
    choices: state.choices
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onChange: function onChange(e) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_ducks_newslist__["d" /* setFilterKey */])(e.target.value));
    }
  };
};

var NewsListFilterConnected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(NewsListFilter);
/* harmony default export */ __webpack_exports__["a"] = (NewsListFilterConnected);

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_news_NewsListFilter__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_news_NewsList__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_newslist__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_text__ = __webpack_require__(4);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }











var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setFilters: function setFilters(filters) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ducks_newslist__["b" /* setFilters */])(filters));
    }
  };
};

var NewsListWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, mapDispatchToProps), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(NewsListWrapper, _Component);

  var _super = _createSuper(NewsListWrapper);

  function NewsListWrapper() {
    var _this;

    _classCallCheck(this, NewsListWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          filterChoices = _this$props.filterChoices,
          selectedFilterKey = _this$props.selectedFilterKey,
          query = _this$props.query;
      var filters = {
        query: query,
        choices: filterChoices
      }; // If category was set in the URL and it is a valid category codename
      // if not, try setting if to All
      // if even that fails, get first filter available

      if (selectedFilterKey && filterChoices.find(function (filter) {
        return filter.key === selectedFilterKey;
      })) {
        filters.filterKey = selectedFilterKey;
      } else if (filterChoices.find(function (filter) {
        return filter.key === 'all';
      })) {
        filters.filterKey = 'all';
      } else {
        filters.filterKey = filterChoices[0].key;
      } // Set all filters in single action


      _this.props.setFilters(filters);
    };

    return _this;
  }

  _createClass(NewsListWrapper, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__header__title arena__header__right"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_text__["a" /* gettext */])('News')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_news_NewsListFilter__["a" /* default */], {
        setTitle: true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_news_NewsList__["a" /* default */], null));
    }
  }]);

  return NewsListWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  setFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  filterChoices: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_utils_shapes__["g" /* SimpleFilterChoiceShape */].isRequired).isRequired,
  selectedFilterKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}, _temp)) || _class);
/* harmony default export */ __webpack_exports__["a"] = (NewsListWrapper);

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Preview__ = __webpack_require__(149);



var SingleArticle = function SingleArticle(_ref) {
  var article = _ref.article;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Preview__["a" /* default */])({
    url: article.url,
    title: article.title,
    subtitle: article.category.description,
    description: article.ingress,
    image: article.facade && article.facade.thumbnail
  });
};

SingleArticle.propTypes = {
  article: __WEBPACK_IMPORTED_MODULE_0_utils_shapes__["h" /* ArticleShape */].isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SingleArticle);

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_text__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ducks_arena__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_scrollElemntIntoView__ = __webpack_require__(237);






var AddMediaToProject = function AddMediaToProject(_ref) {
  var selectedFilterKey = _ref.selectedFilterKey,
      setFilter = _ref.setFilter;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "btn btn-primary",
    onClick: function onClick() {
      if (selectedFilterKey !== 'my') {
        setFilter('my');
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_utils_scrollElemntIntoView__["c" /* scrollElementIntoViewById */])('arena-wrapper', true);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_utils_text__["a" /* gettext */])('Add my work'));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedFilterKey: state.filterKey
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setFilter: function setFilter(name) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ducks_arena__["i" /* setFilterKey */])(name));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(AddMediaToProject));

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_projects_SingleProject__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_projectlist__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Loading__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_text__ = __webpack_require__(4);










var mapStateToProps = function mapStateToProps(state) {
  return {
    items: state.itemIds.map(function (item) {
      return state.items[item];
    }),
    hasMore: state.hasMore,
    startLoad: state.startLoad
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onLoadItems: function onLoadItems() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_ducks_projectlist__["b" /* loadItems */])());
    }
  };
};

var ProjectList = function ProjectList(_ref) {
  var onLoadItems = _ref.onLoadItems,
      hasMore = _ref.hasMore,
      items = _ref.items,
      startLoad = _ref.startLoad;
  var emptyState = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "jumbotron text-center"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('Nothing was found.'));

  var renderItems = function renderItems() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller___default.a, {
      className: "featured",
      initialLoad: false,
      pageStart: 0,
      loadMore: onLoadItems,
      hasMore: hasMore,
      loader: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__loading",
        key: 0
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Loading__["a" /* default */], null))
    }, items.map(function (item) {
      return item ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_projects_SingleProject__["a" /* default */], {
        key: item.id,
        project: item
      }) : null;
    }));
  };

  if (startLoad) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "jumbotron text-center"
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_utils_text__["a" /* gettext */])('Loading… please wait'));
  }

  return items.length ? renderItems() : emptyState;
};

ProjectList.propTypes = {
  onLoadItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  hasMore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_utils_shapes__["i" /* ProjectShape */]).isRequired,
  startLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
var ProjectListConnected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ProjectList);
/* harmony default export */ __webpack_exports__["a"] = (ProjectListConnected);

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_projects_ProjectList__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ducks_projectlist__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_urls__ = __webpack_require__(21);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }









var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadItems: function loadItems() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_ducks_projectlist__["b" /* loadItems */])());
    }
  };
};

var ProjectListWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, mapDispatchToProps), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ProjectListWrapper, _Component);

  var _super = _createSuper(ProjectListWrapper);

  function ProjectListWrapper() {
    var _this;

    _classCallCheck(this, ProjectListWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.componentDidMount = function () {
      // Set all filters in single action
      _this.props.loadItems();
    };

    return _this;
  }

  _createClass(ProjectListWrapper, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__header mb-5"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "arena__header__title arena__header__right"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
        className: "mb-3 nomargins"
      }, gettext('Workshops and competitions')), !this.props.isAuthenticated ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: "button--signup btn",
        href: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_utils_urls__["b" /* default */])('trafo-register')
      }, gettext('Sign up on Trafo to join')) : null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_projects_ProjectList__["a" /* default */], null));
    }
  }]);

  return ProjectListWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class2.propTypes = {
  loadItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isAuthenticated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
}, _temp)) || _class);
/* harmony default export */ __webpack_exports__["a"] = (ProjectListWrapper);

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_shapes__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_urls__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Preview__ = __webpack_require__(149);




__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('nb');

var getUrl = function getUrl(project) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_urls__["b" /* default */])('trafo_project_details_with_seotitle', {
    pk: project.id,
    seotitle: project.seo_title
  });
};

var SingleProject = function SingleProject(_ref) {
  var project = _ref.project;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Preview__["a" /* default */])({
    url: getUrl(project),
    title: project.title,
    subtitle: project.project_type,
    description: project.ingress,
    image: project.facade_thumbnail_large_url
  });
};

SingleProject.propTypes = {
  project: __WEBPACK_IMPORTED_MODULE_0_utils_shapes__["i" /* ProjectShape */].isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SingleProject);

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createReduxStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_logger__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }




var dev = "production" === 'development';
function createReduxStore(reducer) {
  /* eslint-disable */
  var composeEnhancers = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : __WEBPACK_IMPORTED_MODULE_0_redux__["b" /* compose */];
  var middleware = [];
  dev ? middleware.push(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_logger__["createLogger"])()) : middleware.push(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]);
  /* eslint-enable */

  var enhancer = composeEnhancers(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* applyMiddleware */].apply(void 0, middleware));
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(reducer, enhancer);
}

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolveMedia */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resolveStatic; });
var resolveAsset = function resolveAsset(url) {
  var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var path = "".concat(basePath || '').concat(url);

  if (!path.startsWith('/')) {
    path = "/".concat(path);
  }

  return "".concat(path);
};
/**
 * Resolve media file, should be full path e.g `/media/some.pdf`
 * Media files coming from API should have SITE_URL already in front so no need to use this with those.
 * Only using full path cause server will most likely prefix this to the file.
 *
 * @param url - Path to media file without `/media` prefix.
 */


var resolveMedia = function resolveMedia(url) {
  return resolveAsset(url, DJ_CONST.MEDIA_URL);
};
/**
 * Resolve static file, should be full path under static directory.
 * Example: url for `${PROJECT}/static/robots.txt` => `robots.txt`
 *
 * @param url - Path to static file in `/static` directory
 */

var resolveStatic = function resolveStatic(url) {
  return resolveAsset(url, DJ_CONST.STATIC_URL);
};

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Update labels for file fields on change
var handleCustomFileFields = function handleCustomFileFields() {
  var fileFields = document.getElementsByClassName('custom-file-input');

  var _loop = function _loop(i) {
    var fileField = fileFields[i];
    var fileFieldLabel = document.getElementById("label_".concat(fileField.id));
    var originalLabel = fileFieldLabel.innerHTML;
    fileField.addEventListener('change', function () {
      fileFieldLabel.innerHTML = fileField.value ? fileField.value : originalLabel;
    });
  };

  for (var i = 0; i < fileFields.length; i++) {
    _loop(i);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleCustomFileFields);

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setupCommonElements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_BurgerMenu__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_DatePicker__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LimitedTextarea__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_arena_ArenaWrapper__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_mentors_MentorListWrapper__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_projects_ProjectListWrapper__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_projects_AddMediaToProject__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_medlemmer_MemberWrapper__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_news_NewsListWrapper__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Comments__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_CommentForm__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_AvatarProfilePic__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_arena_ArenaPreconfiguredWrapper__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_arena_ArenaBarStandaloneWrapper__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_TrafoPreview__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_ProjectFunds__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_frontpage_slider__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Attachments__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_AttachmentPreviewList__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_arena_EditWork__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_arena_UploadWork__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_ducks_arena__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_ducks_memberlist__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_ducks_mentorlist__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_ducks_newslist__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_ducks_projectlist__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__text__ = __webpack_require__(4);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




























/*
    routeMap expects:
    key (Django urlconf name e.g. qa:home, supports regex): {
        key (standard CSS-syntax, will render to all matching elements): {
            component: React component to render to element
            props (optional): Props to pass to component
            reducer (optional): Redux reducer for the Provider that wraps the component
        }
        excludeCommon: Whether to exclude common elements
    }
 */

var setupCommonElements = function setupCommonElements() {
  return {
    '#burger-menu': {
      component: __WEBPACK_IMPORTED_MODULE_0_components_BurgerMenu__["a" /* default */],
      props: function props() {
        return {
          links: DJ_CONST.BURGER_MENU_LINKS
        };
      }
    }
  };
};
var fundingApplicationUpdate = {
  '.date-picker': {
    component: __WEBPACK_IMPORTED_MODULE_1_components_DatePicker__["a" /* default */],
    props: function props() {
      return {
        required: true
      };
    }
  },
  '#project_costs-component': {
    component: __WEBPACK_IMPORTED_MODULE_15_components_ProjectFunds__["a" /* default */]
  },
  '#funding-component': {
    component: __WEBPACK_IMPORTED_MODULE_15_components_ProjectFunds__["a" /* default */],
    props: function props() {
      return {
        requiredElementDescription: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__text__["a" /* gettext */])('Grant from Trafo'),
        requiredElementDefault: 10000
      };
    }
  },
  '.limited-textarea': {
    component: __WEBPACK_IMPORTED_MODULE_2_components_LimitedTextarea__["a" /* default */],
    props: function props() {
      return {
        countLimit: 2000,
        countShow: true
      };
    }
  }
};
var attachments = {
  component: __WEBPACK_IMPORTED_MODULE_17_components_Attachments__["a" /* default */],
  props: function props() {
    return {
      accept: DJ_CONST.validContentTypes,
      name: 'media',
      initialMediaItems: DJ_CONST.initialMediaItems
    };
  }
};
var attachmentsPreview = {
  component: __WEBPACK_IMPORTED_MODULE_18_components_AttachmentPreviewList__["a" /* default */],
  props: function props() {
    return {
      mediaItems: DJ_CONST.relatedMediaItems
    };
  }
};
var commentsBlock = {
  component: __WEBPACK_IMPORTED_MODULE_9_components_Comments__["a" /* default */],
  props: function props() {
    return {
      modelName: DJ_CONST.modelName,
      pk: DJ_CONST.commentedItem
    };
  }
};
var commentFormBlock = {
  component: __WEBPACK_IMPORTED_MODULE_10_components_CommentForm__["a" /* default */],
  props: function props() {
    return {
      modelName: DJ_CONST.modelName,
      pk: DJ_CONST.commentedItem,
      acceptAttachments: DJ_CONST.acceptCommentAttachments,
      visibilityChoices: DJ_CONST.visibilityChoices
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  'trafo-frontpage': _objectSpread(_objectSpread({}, setupCommonElements()), {}, {
    '#hero-slider': {
      component: __WEBPACK_IMPORTED_MODULE_16_components_frontpage_slider__["a" /* default */],
      props: function props() {
        return {
          images: DJ_CONST.frontPageImages,
          theme: DJ_CONST.frontPageSliderTheme || 'white',
          periodUntil: DJ_CONST.moneyPeriodUntil || ''
        };
      }
    },
    '#comments__guestmentor': {
      component: __WEBPACK_IMPORTED_MODULE_9_components_Comments__["a" /* default */],
      props: function props() {
        return {
          commentType: __WEBPACK_IMPORTED_MODULE_9_components_Comments__["a" /* default */].commentTypes.GUESTMENTOR,
          title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__text__["a" /* gettext */])('Guest mentor'),
          contentAndImageLinks: true
        };
      }
    },
    '#comments__public': {
      component: __WEBPACK_IMPORTED_MODULE_9_components_Comments__["a" /* default */],
      props: function props() {
        return {
          commentType: __WEBPACK_IMPORTED_MODULE_9_components_Comments__["a" /* default */].commentTypes.PUBLIC,
          title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__text__["a" /* gettext */])('Comments by regular users'),
          contentAndImageLinks: true
        };
      }
    }
  }),
  'trafo-register': {
    '#birthdate-picker': {
      component: __WEBPACK_IMPORTED_MODULE_1_components_DatePicker__["a" /* default */],
      props: function props() {
        return {
          required: true,
          provideDefaultDate: false
        };
      }
    }
  },
  trafo_fundingapplication_add: fundingApplicationUpdate,
  trafo_fundingapplication_details: fundingApplicationUpdate,
  trafo_fundingapplication_attachments: {
    '#attachments-component': attachments
  },
  trafo_mentorapplication_attachments: {
    '#attachments-component': attachments
  },
  trafo_fundingapplication_previewandaccept: {
    '#related-files-component': attachmentsPreview
  },
  trafo_mentorapplication_previewandaccept: {
    '#related-files-component': attachmentsPreview
  },
  trafo_fundingapplication_process: {
    '#related-files-component': attachmentsPreview,
    '.comments-component-root': commentsBlock,
    '.comments__form': commentFormBlock
  },
  trafo_mentorapplication_process: {
    '#related-files-component': attachmentsPreview,
    '.comments-component-root': commentsBlock,
    '.comments__form': commentFormBlock
  },
  trafo_arena_browse: {
    '#arena-wrapper': {
      component: __WEBPACK_IMPORTED_MODULE_3_components_arena_ArenaWrapper__["a" /* default */],
      reducer: __WEBPACK_IMPORTED_MODULE_21_ducks_arena__["a" /* default */],
      props: function props() {
        return {
          filterChoices: DJ_CONST.filterChoices,
          selectedFilterKey: DJ_CONST.selectedFilterKey,
          selectedOrdering: DJ_CONST.selectedOrdering,
          query: DJ_CONST.query
        };
      }
    }
  },
  trafo_arena_listmembers: {
    '#arena-wrapper': {
      component: __WEBPACK_IMPORTED_MODULE_7_components_medlemmer_MemberWrapper__["a" /* default */],
      reducer: __WEBPACK_IMPORTED_MODULE_22_ducks_memberlist__["a" /* default */],
      props: function props() {
        return {
          filterChoices: DJ_CONST.filterChoices,
          selectedFilterKey: DJ_CONST.selectedFilterKey,
          selectedOrdering: DJ_CONST.selectedOrdering,
          query: DJ_CONST.query
        };
      }
    }
  },
  trafo_member_editprofile: {
    '.limited-textarea': {
      component: __WEBPACK_IMPORTED_MODULE_2_components_LimitedTextarea__["a" /* default */],
      props: function props() {
        return {
          countLimit: 1500,
          countShow: true
        };
      }
    }
  },
  trafo_member_profile_with_seotitle: {
    '#arena-wrapper': {
      component: __WEBPACK_IMPORTED_MODULE_12_components_arena_ArenaPreconfiguredWrapper__["a" /* default */],
      reducer: __WEBPACK_IMPORTED_MODULE_21_ducks_arena__["a" /* default */],
      props: function props() {
        return {
          filterChoices: DJ_CONST.filterChoices,
          selectedFilterKey: DJ_CONST.selectedFilterKey
        };
      }
    }
  },
  trafo_arena_media_add: {
    '#media-upload-component': {
      component: __WEBPACK_IMPORTED_MODULE_20_components_arena_UploadWork__["a" /* default */],
      props: function props() {
        return {
          accept: DJ_CONST.validContentTypes,
          textAlignOptions: DJ_CONST.textAlignOptions,
          textFontOptions: DJ_CONST.textFontOptions,
          textLineheightOptions: DJ_CONST.textLineheightOptions,
          initialValues: DJ_CONST.initialValues,
          errors: DJ_CONST.errors
        };
      }
    }
  },
  trafo_arena_media_edit: {
    '#media-upload-component': {
      component: __WEBPACK_IMPORTED_MODULE_19_components_arena_EditWork__["a" /* default */],
      props: function props() {
        return {
          objectId: DJ_CONST.objectId,
          accept: DJ_CONST.validContentTypes,
          textAlignOptions: DJ_CONST.textAlignOptions,
          textFontOptions: DJ_CONST.textFontOptions,
          textLineheightOptions: DJ_CONST.textLineheightOptions,
          privacyOptions: DJ_CONST.privacyOptions,
          initialValues: DJ_CONST.initialValues,
          errors: DJ_CONST.errors
        };
      }
    }
  },
  trafo_arena_media_details_with_seotitle: {
    '#arena-wrapper': {
      component: __WEBPACK_IMPORTED_MODULE_12_components_arena_ArenaPreconfiguredWrapper__["a" /* default */],
      reducer: __WEBPACK_IMPORTED_MODULE_21_ducks_arena__["a" /* default */],
      store: 'trafo_arena_media_details_with_seotitle-#arena',
      props: function props() {
        return {
          filterChoices: DJ_CONST.filterChoices,
          selectedFilterKey: DJ_CONST.selectedFilterKey,
          excludeItem: DJ_CONST.initialItem.id
        };
      }
    },
    '#trafo-artwork-standalone-icon-bar': {
      component: __WEBPACK_IMPORTED_MODULE_13_components_arena_ArenaBarStandaloneWrapper__["a" /* default */],
      reducer: __WEBPACK_IMPORTED_MODULE_21_ducks_arena__["a" /* default */],
      store: 'trafo_arena_media_details_with_seotitle-#arena',
      props: function props() {
        return {
          initialItem: DJ_CONST.initialItem,
          commentsLink: '#comments'
        };
      }
    },
    '#trafo-artwork__preview-target': {
      component: __WEBPACK_IMPORTED_MODULE_14_components_TrafoPreview__["a" /* default */],
      props: function props() {
        return {
          mediaItem: DJ_CONST.initialItem,
          size: 'large',
          showPreview: true,
          finishedLoadingCallback: DJ_CONST.initTrafoVideoAndAudio,
          showNewlyPublished: DJ_CONST.showNewlyPublished,
          showUnavailable: true
        };
      }
    },
    '.comments-component-root': commentsBlock,
    '.comments__form': commentFormBlock
  },
  trafo_application_mentoroverview: {
    '#mentors-wrapper': {
      component: __WEBPACK_IMPORTED_MODULE_4_components_mentors_MentorListWrapper__["a" /* default */],
      reducer: __WEBPACK_IMPORTED_MODULE_23_ducks_mentorlist__["a" /* default */],
      props: function props() {
        return {
          filterChoices: DJ_CONST.filterChoices,
          selectedFilterKey: DJ_CONST.selectedFilterKey,
          query: DJ_CONST.query
        };
      }
    }
  },
  trafo_project_frontpage: {
    '#projects-wrapper': {
      component: __WEBPACK_IMPORTED_MODULE_5_components_projects_ProjectListWrapper__["a" /* default */],
      reducer: __WEBPACK_IMPORTED_MODULE_25_ducks_projectlist__["a" /* default */],
      props: function props() {
        return {
          isAuthenticated: DJ_CONST.isAuthenticated
        };
      }
    }
  },
  trafo_news_frontpage: {
    '#news-wrapper': {
      component: __WEBPACK_IMPORTED_MODULE_8_components_news_NewsListWrapper__["a" /* default */],
      reducer: __WEBPACK_IMPORTED_MODULE_24_ducks_newslist__["a" /* default */],
      props: function props() {
        return {
          filterChoices: DJ_CONST.filterChoices,
          selectedFilterKey: DJ_CONST.selectedFilterKey,
          query: DJ_CONST.query
        };
      }
    }
  },
  trafo_news_details_with_seotitle: {
    '.comments-component-root': commentsBlock,
    '.comments__form': commentFormBlock
  },
  trafo_project_details_with_seotitle: {
    '.comments-component-root': commentsBlock,
    '.comments__form': commentFormBlock,
    '#add-project-media-button': {
      component: __WEBPACK_IMPORTED_MODULE_6_components_projects_AddMediaToProject__["a" /* default */],
      reducer: __WEBPACK_IMPORTED_MODULE_21_ducks_arena__["a" /* default */],
      store: 'trafo_project_details_with_seotitle-#arena'
    },
    '#arena-wrapper': {
      component: __WEBPACK_IMPORTED_MODULE_12_components_arena_ArenaPreconfiguredWrapper__["a" /* default */],
      reducer: __WEBPACK_IMPORTED_MODULE_21_ducks_arena__["a" /* default */],
      store: 'trafo_project_details_with_seotitle-#arena',
      props: function props() {
        return {
          filterChoices: DJ_CONST.filterChoices,
          selectedFilterKey: DJ_CONST.selectedFilterKey,
          actionCallbackFactory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_components_arena_ArenaPreconfiguredWrapper__["b" /* makeAddAndRemoveFromProjectCallbackFactory */])({
            projectId: DJ_CONST.projectId,
            user: DJ_CONST.user,
            isParticipant: DJ_CONST.isParticipant,
            projectIsActive: DJ_CONST.projectIsActive
          })
        };
      }
    }
  },
  trafo_member_editavatar: {
    '#upload-profile-pic': {
      component: __WEBPACK_IMPORTED_MODULE_11_components_AvatarProfilePic__["a" /* default */],
      props: function props() {
        return {
          accept: DJ_CONST.accept,
          initialAvatar: DJ_CONST.initialAvatar
        };
      }
    }
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Loading = function Loading() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "spinner"
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ErrorShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorsShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SelectOptionsShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ItemContentShape; });
/* unused harmony export UserShape */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MediaCacheShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MemberShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MediaItemShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FilterChoiceShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SimpleFilterChoiceShape; });
/* unused harmony export RequestCategoryShape */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MentorShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ProjectShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FPImageShape; });
/* unused harmony export ArticleCategoryShape */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ArticleShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var ErrorShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  code: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}))]);
var ErrorsShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(ErrorShape);
var SelectOptionsShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]),
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node])
}));
var ItemContentShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  thumbnail_url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
});
var UserShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  avatar_url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  avatar_url_medium: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  date_joined: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  consultant: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    cat: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
      name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
    }))
  })
});
var MediaCacheShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  content_preview: ItemContentShape.isRequired,
  content_type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['MediaCache']).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  is_talent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  media: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  number_of_favourites: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  number_of_public_comments: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  number_of_visits: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  user: UserShape
});
var MemberShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  num_logins: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  content_preview: ItemContentShape.isRequired,
  content_type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['Member']).isRequired,
  number_of_public_comments: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  number_of_public_uploads: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  age: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  user: UserShape
});
var MediaItemShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});
var FilterChoiceShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  filter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  // eslint-disable-line
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  contentType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  allowUploadNew: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  extraQueryParams: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string)
});
var SimpleFilterChoiceShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});
var RequestCategoryShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  codename: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  active: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired
});
var MentorShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  is_consultant: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  user: UserShape,
  info: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  cat: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(RequestCategoryShape)
});
var ProjectShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  seo_title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  ingress: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  project_type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  facade_thumbnail_large_url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});
var FPImageShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  order: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  author: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  flavour: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});
var ArticleCategoryShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  codename: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});
var ArticleShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  slug: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  ingress: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  category: ArticleCategoryShape.isRequired,
  facade: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    thumbnail: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  }).isRequired,
  created_at: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shapes__ = __webpack_require__(7);




var FieldErrors = function FieldErrors(_ref) {
  var error = _ref.error,
      className = _ref.className;
  if (!error) return null;
  var errors = [];

  if (typeof error === 'string') {
    errors = [error];
  } else if (error instanceof Array) {
    errors = error;
  }

  if (errors.length < 1) {
    return null;
  }

  return errors.map(function (fieldError) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: className,
      key: fieldError.message
    }, fieldError.message);
  });
};

FieldErrors.propTypes = {
  error: __WEBPACK_IMPORTED_MODULE_2__utils_shapes__["b" /* ErrorShape */],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
FieldErrors.defaultProps = {
  error: null,
  className: 'invalid-feedback' // Default for bootstrap4

};
/* harmony default export */ __webpack_exports__["a"] = (FieldErrors);

/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(454);
module.exports = __webpack_require__(452);


/***/ })

},[937]);


// WEBPACK FOOTER //
// app/app-c9dbc3b47864e4116240.js